import { ReactComponent as DashBoardSVG } from "../../images/DashBoard.svg";
import { ReactComponent as LeadSvg } from "../../images/Leads.svg";
import { ReactComponent as CustomerSvg } from "../../images/Customers.svg";
import { ReactComponent as ProjectsSvg } from "../../images/Projects.svg";
import { ReactComponent as AgreementsSvg } from "../../images/Agreements.svg";
import { ReactComponent as MastersSvg } from "../../images/Masters.svg";

import { ReactComponent as InventorySvg } from "../../images/Inventory.svg";
import { ReactComponent as TasksSvg } from "../../images/Tasks.svg";
import { ReactComponent as BoardSvg } from "../../images/Board.svg";
import { ReactComponent as ChartOfAccountsSvg } from "../../images/Chart of Accounts.svg";
import { ReactComponent as GeneralLedgerSvg } from "../../images/General Ledger.svg";
import { ReactComponent as PayrollSvg } from "../../images/Payroll.svg";
import { ReactComponent as EmployeeSvg } from "../../images/Employee.svg";
import { ReactComponent as UsersSvg } from "../../images/Users.svg";



import { ReactComponent as  Transactions } from "../../images/newIcons/Icons-03.svg";
import { ReactComponent as  Billings } from "../../images/newIcons/Icons-02.svg";

import { ReactComponent as Budgeting } from "../../images/newIcons/Icons-04.svg";
import { ReactComponent as  FinancialPeriods } from "../../images/newIcons/Icons-05.svg";
import { ReactComponent as Expenses } from "../../images/newIcons/Icons-06.svg";
import { ReactComponent as Incomes } from "../../images/newIcons/Icons-07.svg";
import { ReactComponent as Reports } from "../../images/newIcons/Icons-08.svg";
import { ReactComponent as Settings } from "../../images/newIcons/Icons-09.svg";
import { ReactComponent as  TaxManagement } from "../../images/newIcons/Icons-10.svg";
//-----------------------------------//
import {ReactComponent as LeaveManagement} from "../../images/LeavesManagement.svg";
import {ReactComponent as Attendence} from "../../images/Attendence.svg";
import {ReactComponent as Holiday} from "../../images/Holiday.svg";
import {ReactComponent as Suppliers} from "../../images/Suppliers.svg";
import {ReactComponent as HRManagers} from "../../images/HRManagers.svg";


import styled from "styled-components";

export const IMAGES = {
  User: require("../../images/user.jpg"),
  Avatar: require("../../images/avatar/1.jpg"),
  contact1: require("../../images/contacts/pic1.jpg"),
  contact2: require("../../images/contacts/pic2.jpg"),
  contact3: require("../../images/contacts/pic3.jpg"),
  contact4: require("../../images/contacts/d4.jpg"),
  contact5: require("../../images/contacts/pic555.jpg"),
  contact6: require("../../images/contacts/pic666.jpg"),
  contact7: require("../../images/contacts/pic777.jpg"),
  contact8: require("../../images/contacts/pic888.jpg"),
  contact9: require("../../images/contacts/pic999.jpg"),

  Uidesign: require("../../images/uidesgn.png"),
  Items: require("../../images/items.png"),
  budget: require("../../images/budgeting.png"),
  window: require("../../images/windows.jpg"),
  osimg1: require("../../images/os/p1.jpg"),
  osimg2: require("../../images/os/p2.jpg"),
  osimg3: require("../../images/os/p3.jpg"),
  osimg5: require("../../images/os/p5.jpg"),

  dribble: require("../../images/crm/dribble.png"),
  facebook: require("../../images/crm/facebook.png"),
  instagram: require("../../images/crm/instagram.png"),
  linkdin: require("../../images/crm/linkedin.png"),
  bing: require("../../images/crm/bing.png"),
  twitter: require("../../images/crm/twitter.png"),
  whatsapp: require("../../images/crm/whatsapp.png"),
  pinterest: require("../../images/crm/pinterest.png"),
  PieChart: require("../../images/crm/pie-chart.png"),

  popper: require("../../images/crm/party-popper.png"),
  object: require("../../images/crm/Object.png"),
  develop: require("../../images/analytics/developer_male.png"),
  sales: require("../../images/analytics/sales.png"),
  shopping: require("../../images/analytics/shopping.png"),

  india: require("../../images/country/india.png"),
  usa: require("../../images/country/usa.png"),
  canada: require("../../images/country/canada.png"),
  china: require("../../images/country/china.png"),
  kingdom: require("../../images/country/united-kingdom.png"),
  ac: require("../../images/contacts/d14.jpg"),
  beg: require("../../images/contacts/d10.jpg"),
  dress: require("../../images/contacts/d11.jpg"),
  jacket: require("../../images/contacts/d12.jpg"),

  Books: require("../../images/books.png"),
  News: require("../../images/news.png"),
  Heart: require("../../images/heart.png"),
  File: require("../../images/file.png"),

  Professional: require("../../images/blog/professional.jpg"),
  Professional2: require("../../images/blog/professional2.jpg"),
  Friends1: require("../../images/profile/friends/f1.jpg"),
  Friends2: require("../../images/profile/friends/f2.jpg"),
  Friends3: require("../../images/profile/friends/f3.jpg"),
  Friends4: require("../../images/profile/friends/f4.jpg"),
  User1: require("../../images/user1.jpg"),

  Blogs1: require("../../images/blog/s1.jpg"),
  Blogs2: require("../../images/blog/s2.jpg"),
  Blogs3: require("../../images/blog/s3.jpg"),
  Blogs4: require("../../images/blog/s4.jpg"),
  Blogs5: require("../../images/blog/s5.jpg"),
  Blogs6: require("../../images/blog/s6.jpg"),

  Profile1: require("../../images/profile/1.jpg"),
  Profile2: require("../../images/profile/2.jpg"),
  Profile3: require("../../images/profile/3.jpg"),
  Profile4: require("../../images/profile/4.jpg"),
  Profile5: require("../../images/profile/5.jpg"),
  Profile6: require("../../images/profile/6.jpg"),
  Profile7: require("../../images/profile/7.jpg"),
  Profile8: require("../../images/profile/8.jpg"),
  Profile9: require("../../images/profile/9.jpg"),

  Product2: require("../../images/product/2.jpg"),
  Product3: require("../../images/product/3.jpg"),
  Product4: require("../../images/product/4.jpg"),
  Product5: require("../../images/product/5.jpg"),
  Product6: require("../../images/product/6.jpg"),
  Product7: require("../../images/product/7.jpg"),

  Post1: require("../../images/post/post1.jpg"),
  Post2: require("../../images/post/post2.jpg"),
  Post11: require("../../images/post/post11.jpg"),
  Post12: require("../../images/post/post12.jpg"),
  Post13: require("../../images/post/post13.jpg"),
};

const HoverableIcon = styled.div`
  &:hover {
    cursor: pointer;
    // Change the color to your desired color when hovered
    svg {
      fill: #f8b940;
    }
  }
`;
export const SVGICON = {
  DashBoardSVG: (
    <HoverableIcon>
      <DashBoardSVG
        width="24"
        height="24"
        fill="#fff"
        xmlns="http://www.w3.org/2000/svg"
      />
    </HoverableIcon>
  ),
  LeadSvg: (
    <LeadSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  CustomerSvg: (
    <CustomerSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Projects: (
    <ProjectsSvg
      width="24"
      height="24"
      
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Agreements: (
    <AgreementsSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Masters: (
    <MastersSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Inventory: (
    <InventorySvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Tasks: (
    <TasksSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Board: (
    <BoardSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  ChartOfAccounts: (
    <ChartOfAccountsSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  GeneralLedger: (
    <GeneralLedgerSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  PayRoll: (
    <PayrollSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Employee: (
    <EmployeeSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  Transactions: (<Transactions width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  Budgeting: (<Budgeting width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  Billings: (<Billings width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  FinancialPeriods: (<FinancialPeriods width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  Expenses: (<Expenses width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  Incomes: (<Incomes width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  Reports: (<Reports width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  Settings: (<Settings width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />),
  TaxManagement: (<TaxManagement width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />)
,
LeaveManagement: (
  <LeaveManagement width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)"  />
),
Attendance: (
  <Attendence width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)"  />
),
Holiday: (
  <Holiday width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />
),
Suppliers: (
  <Suppliers width="24" height="24" fill="none" className="menu-icon" xmlns="(link unavailable)" />
),
HRManagers:(
  <HRManagers width="24" height="24"full="none" className="menu-icon" xmlns="(link unavailable)" />
),
  Users: (
    <UsersSvg
      width="24"
      height="24"
      fill="none"
      className="menu-icon"
      xmlns="http://www.w3.org/2000/svg"
    />
  ),
  MainLogo: (
    <svg
      className="logo-abbr"
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.3287 2.96046L26.3411 0.0805375C26.1549 -0.0268458 25.9256 -0.0268458 25.7394 0.0805375C19.754 3.53731 12.3785 3.53785 6.39259 0.0816161L6.39043 0.0805375C6.20426 -0.0268458 5.97493 -0.0268458 5.78876 0.0805375L0.801104 2.95992C0.614937 3.0673 0.5 3.26588 0.5 3.48119V9.24049C0.5 9.4558 0.614937 9.65438 0.801104 9.76176C6.78759 13.2169 10.4753 19.6038 10.4753 26.5162V26.5184C10.4753 26.7332 10.5903 26.9323 10.7764 27.0397L15.7641 29.9196C15.8574 29.9736 15.961 30 16.0652 30C16.1693 30 16.2729 29.973 16.3663 29.9196L21.3539 27.0397C21.5401 26.9323 21.655 26.7337 21.655 26.5184C21.6545 19.6059 25.3422 13.2185 31.3287 9.7623L31.3298 9.76176C31.516 9.65438 31.6309 9.4558 31.6309 9.24049V3.48173C31.6293 3.26642 31.5149 3.06784 31.3287 2.96046ZM30.4259 8.89352L15.7635 17.359C15.5774 17.4664 15.4624 17.665 15.4624 17.8803V22.4168C14.9876 22.651 14.6692 23.1534 14.7043 23.7259C14.7458 24.3993 15.2854 24.9471 15.9589 24.9978C16.7591 25.0582 17.4272 24.4263 17.4272 23.639C17.4272 23.1026 17.1169 22.6386 16.6663 22.4163C16.6663 19.824 18.0493 17.4286 20.2941 16.1324L20.4496 16.0429L20.4501 26.1714L16.0641 28.7038L11.6781 26.1714V9.24103C11.6781 9.02627 11.5632 8.82715 11.377 8.71976L7.44754 6.45123C7.4497 6.42155 7.45078 6.39187 7.45078 6.36165C7.45078 5.59162 6.81187 4.97052 6.03537 5.0002C5.32901 5.02718 4.75378 5.60241 4.7268 6.30877C4.69712 7.08527 5.31822 7.72471 6.08825 7.72471C6.36885 7.72471 6.62948 7.63999 6.84587 7.49484C9.09066 8.79099 10.4737 11.1863 10.4737 13.7786V13.9573L1.70172 8.89406V3.82978L6.08771 1.29737L20.7501 9.76284C20.9363 9.87022 21.1656 9.87022 21.3518 9.76284L25.2807 7.4943C25.4993 7.64108 25.7631 7.72579 26.0464 7.72417C26.7895 7.71986 27.3998 7.10686 27.4009 6.36381C27.4019 5.60997 26.7916 4.99912 26.0383 4.99912C25.2856 4.99912 24.6758 5.60943 24.6758 6.36165C24.6758 6.39187 24.6769 6.42155 24.6791 6.45123C22.4337 7.74738 19.6676 7.74738 17.4223 6.45123L17.268 6.36219L26.0383 1.29737L30.4243 3.82978V8.89352H30.4259Z"
        fill="white"
      />
    </svg>
  ),
  logotitle: (
    <svg
      className="brand-title"
      width="111"
      height="24"
      viewBox="0 0 111 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="yesh"
        width="49"
        height="22"
        transform="translate(0 1)"
        fill="white"
      />
      <path
        className="admin1"
        d="M14.296 7.172L10.894 13.752V17H8.5V13.752L5.098 7.172H7.814L9.718 11.288L11.608 7.172H14.296ZM21.3786 15.264H17.7106L17.1226 17H14.6166L18.1726 7.172H20.9446L24.5006 17H21.9666L21.3786 15.264ZM20.7626 13.416L19.5446 9.818L18.3406 13.416H20.7626ZM29.1388 17.098C28.4202 17.098 27.7762 16.9813 27.2068 16.748C26.6375 16.5147 26.1802 16.1693 25.8348 15.712C25.4988 15.2547 25.3215 14.704 25.3028 14.06H27.8508C27.8882 14.424 28.0142 14.704 28.2288 14.9C28.4435 15.0867 28.7235 15.18 29.0688 15.18C29.4235 15.18 29.7035 15.1007 29.9088 14.942C30.1142 14.774 30.2168 14.5453 30.2168 14.256C30.2168 14.0133 30.1328 13.8127 29.9648 13.654C29.8062 13.4953 29.6055 13.3647 29.3628 13.262C29.1295 13.1593 28.7935 13.0427 28.3548 12.912C27.7202 12.716 27.2022 12.52 26.8008 12.324C26.3995 12.128 26.0542 11.8387 25.7648 11.456C25.4755 11.0733 25.3308 10.574 25.3308 9.958C25.3308 9.04333 25.6622 8.32933 26.3248 7.816C26.9875 7.29333 27.8508 7.032 28.9148 7.032C29.9975 7.032 30.8702 7.29333 31.5328 7.816C32.1955 8.32933 32.5502 9.048 32.5968 9.972H30.0068C29.9882 9.65467 29.8715 9.40733 29.6568 9.23C29.4422 9.04333 29.1668 8.95 28.8308 8.95C28.5415 8.95 28.3082 9.02933 28.1308 9.188C27.9535 9.33733 27.8648 9.55667 27.8648 9.846C27.8648 10.1633 28.0142 10.4107 28.3128 10.588C28.6115 10.7653 29.0782 10.9567 29.7128 11.162C30.3475 11.3767 30.8608 11.582 31.2528 11.778C31.6542 11.974 31.9995 12.2587 32.2888 12.632C32.5782 13.0053 32.7228 13.486 32.7228 14.074C32.7228 14.634 32.5782 15.1427 32.2888 15.6C32.0088 16.0573 31.5982 16.4213 31.0568 16.692C30.5155 16.9627 29.8762 17.098 29.1388 17.098ZM42.7081 7.172V17H40.3141V12.954H36.5901V17H34.1961V7.172H36.5901V11.022H40.3141V7.172H42.7081Z"
        fill="#222B40"
      />
      <path
        className="admin2"
        d="M63.484 16.016H59.292L58.62 18H55.756L59.82 6.768H62.988L67.052 18H64.156L63.484 16.016ZM62.78 13.904L61.388 9.792L60.012 13.904H62.78ZM72.4969 6.768C73.6809 6.768 74.7155 7.00267 75.6009 7.472C76.4862 7.94133 77.1689 8.60267 77.6489 9.456C78.1395 10.2987 78.3849 11.2747 78.3849 12.384C78.3849 13.4827 78.1395 14.4587 77.6489 15.312C77.1689 16.1653 76.4809 16.8267 75.5849 17.296C74.6995 17.7653 73.6702 18 72.4969 18H68.2889V6.768H72.4969ZM72.3209 15.632C73.3555 15.632 74.1609 15.3493 74.7369 14.784C75.3129 14.2187 75.6009 13.4187 75.6009 12.384C75.6009 11.3493 75.3129 10.544 74.7369 9.968C74.1609 9.392 73.3555 9.104 72.3209 9.104H71.0249V15.632H72.3209ZM92.6339 6.768V18H89.8979V11.264L87.3859 18H85.1779L82.6499 11.248V18H79.9139V6.768H83.1459L86.2979 14.544L89.4179 6.768H92.6339ZM97.3374 6.768V18H94.6014V6.768H97.3374ZM109.368 18H106.632L102.056 11.072V18H99.3201V6.768H102.056L106.632 13.728V6.768H109.368V18Z"
        fill="white"
      />
    </svg>
  ),
  NavHeaderIcon: (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7468 5.58925C11.0722 5.26381 11.0722 4.73617 10.7468 4.41073C10.4213 4.0853 9.89369 4.0853 9.56826 4.41073L4.56826 9.41073C4.25277 9.72622 4.24174 10.2342 4.54322 10.5631L9.12655 15.5631C9.43754 15.9024 9.96468 15.9253 10.3039 15.6143C10.6432 15.3033 10.6661 14.7762 10.3551 14.4369L6.31096 10.0251L10.7468 5.58925Z"
        fill="#452B90"
      />
      <path
        opacity="0.3"
        d="M16.5801 5.58924C16.9056 5.26381 16.9056 4.73617 16.5801 4.41073C16.2547 4.0853 15.727 4.0853 15.4016 4.41073L10.4016 9.41073C10.0861 9.72622 10.0751 10.2342 10.3766 10.5631L14.9599 15.5631C15.2709 15.9024 15.798 15.9253 16.1373 15.6143C16.4766 15.3033 16.4995 14.7762 16.1885 14.4369L12.1443 10.0251L16.5801 5.58924Z"
        fill="#452B90"
      />
    </svg>
  ),
  SearchIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_450)">
        <path
          opacity="0.3"
          d="M14.2929 16.7071C13.9024 16.3166 13.9024 15.6834 14.2929 15.2929C14.6834 14.9024 15.3166 14.9024 15.7071 15.2929L19.7071 19.2929C20.0976 19.6834 20.0976 20.3166 19.7071 20.7071C19.3166 21.0976 18.6834 21.0976 18.2929 20.7071L14.2929 16.7071Z"
          fill="#452B90"
        />
        <path
          d="M11 16C13.7614 16 16 13.7614 16 11C16 8.23859 13.7614 6.00002 11 6.00002C8.23858 6.00002 6 8.23859 6 11C6 13.7614 8.23858 16 11 16ZM11 18C7.13401 18 4 14.866 4 11C4 7.13402 7.13401 4.00002 11 4.00002C14.866 4.00002 18 7.13402 18 11C18 14.866 14.866 18 11 18Z"
          fill="#452B90"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_450">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  MailIcon: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1_463)">
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 2H18.5C19.0523 2 19.5 2.44772 19.5 3V13C19.5 13.5523 19.0523 14 18.5 14H6.5C5.94772 14 5.5 13.5523 5.5 13V3C5.5 2.44772 5.94772 2 6.5 2ZM14.3 4C13.6562 4 12.9033 4.72985 12.5 5.2C12.0967 4.72985 11.3438 4 10.7 4C9.5604 4 8.9 4.88887 8.9 6.02016C8.9 7.27339 10.1 8.6 12.5 10C14.9 8.6 16.1 7.3 16.1 6.1C16.1 4.96871 15.4396 4 14.3 4Z"
          fill="#222B40"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.29275 6.57254L12.5 12.5L20.7073 6.57254C20.9311 6.41086 21.2437 6.46127 21.4053 6.68514C21.4669 6.77034 21.5 6.87278 21.5 6.97788V17C21.5 18.1046 20.6046 19 19.5 19H5.5C4.39543 19 3.5 18.1046 3.5 17V6.97788C3.5 6.70174 3.72386 6.47788 4 6.47788C4.10511 6.47788 4.20754 6.511 4.29275 6.57254Z"
          fill="#222B40"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_463">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  CalenderIcon: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 16.87V9.257H21.5V16.931C21.5 20.07 19.5241 22 16.3628 22H8.62733C5.49561 22 3.5 20.03 3.5 16.87ZM8.45938 14.41C8.00494 14.431 7.62953 14.07 7.60977 13.611C7.60977 13.151 7.96542 12.771 8.41987 12.75C8.86443 12.75 9.22997 13.101 9.23985 13.55C9.2596 14.011 8.90395 14.391 8.45938 14.41ZM12.5198 14.41C12.0653 14.431 11.6899 14.07 11.6701 13.611C11.6701 13.151 12.0258 12.771 12.4802 12.75C12.9248 12.75 13.2903 13.101 13.3002 13.55C13.32 14.011 12.9643 14.391 12.5198 14.41ZM16.5505 18.09C16.096 18.08 15.7305 17.7 15.7305 17.24C15.7206 16.78 16.0862 16.401 16.5406 16.391H16.5505C17.0148 16.391 17.3902 16.771 17.3902 17.24C17.3902 17.71 17.0148 18.09 16.5505 18.09ZM11.6701 17.24C11.6899 17.7 12.0653 18.061 12.5198 18.04C12.9643 18.021 13.32 17.641 13.3002 17.181C13.2903 16.731 12.9248 16.38 12.4802 16.38C12.0258 16.401 11.6701 16.78 11.6701 17.24ZM7.59989 17.24C7.61965 17.7 7.99506 18.061 8.44951 18.04C8.89407 18.021 9.24973 17.641 9.22997 17.181C9.22009 16.731 8.85456 16.38 8.40999 16.38C7.95554 16.401 7.59989 16.78 7.59989 17.24ZM15.7404 13.601C15.7404 13.141 16.096 12.771 16.5505 12.761C16.9951 12.761 17.3507 13.12 17.3705 13.561C17.3804 14.021 17.0247 14.401 16.5801 14.41C16.1257 14.42 15.7503 14.07 15.7404 13.611V13.601Z"
        fill="#222B40"
      />
      <path
        opacity="0.4"
        d="M3.50336 9.2569C3.5162 8.6699 3.5656 7.5049 3.65846 7.1299C4.13267 5.0209 5.74298 3.6809 8.04485 3.4899H16.9559C19.238 3.6909 20.8681 5.0399 21.3423 7.1299C21.4342 7.4949 21.4836 8.6689 21.4964 9.2569H3.50336Z"
        fill="#222B40"
      />
      <path
        d="M8.80489 6.59C9.23958 6.59 9.56559 6.261 9.56559 5.82V2.771C9.56559 2.33 9.23958 2 8.80489 2C8.3702 2 8.04419 2.33 8.04419 2.771V5.82C8.04419 6.261 8.3702 6.59 8.80489 6.59Z"
        fill="#222B40"
      />
      <path
        d="M16.195 6.59C16.6198 6.59 16.9557 6.261 16.9557 5.82V2.771C16.9557 2.33 16.6198 2 16.195 2C15.7603 2 15.4343 2.33 15.4343 2.771V5.82C15.4343 6.261 15.7603 6.59 16.195 6.59Z"
        fill="#222B40"
      />
    </svg>
  ),
  calender: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3787 1.875H15.625V1.25C15.625 1.08424 15.5592 0.925268 15.4419 0.808058C15.3247 0.690848 15.1658 0.625 15 0.625C14.8342 0.625 14.6753 0.690848 14.5581 0.808058C14.4408 0.925268 14.375 1.08424 14.375 1.25V1.875H10.625V1.25C10.625 1.08424 10.5592 0.925268 10.4419 0.808058C10.3247 0.690848 10.1658 0.625 10 0.625C9.83424 0.625 9.67527 0.690848 9.55806 0.808058C9.44085 0.925268 9.375 1.08424 9.375 1.25V1.875H5.625V1.25C5.625 1.08424 5.55915 0.925268 5.44194 0.808058C5.32473 0.690848 5.16576 0.625 5 0.625C4.83424 0.625 4.67527 0.690848 4.55806 0.808058C4.44085 0.925268 4.375 1.08424 4.375 1.25V1.875H3.62125C2.99266 1.87599 2.3901 2.12614 1.94562 2.57062C1.50114 3.0151 1.25099 3.61766 1.25 4.24625V17.0037C1.25099 17.6323 1.50114 18.2349 1.94562 18.6794C2.3901 19.1239 2.99266 19.374 3.62125 19.375H16.3787C17.0073 19.374 17.6099 19.1239 18.0544 18.6794C18.4989 18.2349 18.749 17.6323 18.75 17.0037V4.24625C18.749 3.61766 18.4989 3.0151 18.0544 2.57062C17.6099 2.12614 17.0073 1.87599 16.3787 1.875ZM17.5 17.0037C17.499 17.3008 17.3806 17.5854 17.1705 17.7955C16.9604 18.0056 16.6758 18.124 16.3787 18.125H3.62125C3.32418 18.124 3.03956 18.0056 2.8295 17.7955C2.61944 17.5854 2.50099 17.3008 2.5 17.0037V4.24625C2.50099 3.94918 2.61944 3.66456 2.8295 3.4545C3.03956 3.24444 3.32418 3.12599 3.62125 3.125H4.375V3.75C4.375 3.91576 4.44085 4.07473 4.55806 4.19194C4.67527 4.30915 4.83424 4.375 5 4.375C5.16576 4.375 5.32473 4.30915 5.44194 4.19194C5.55915 4.07473 5.625 3.91576 5.625 3.75V3.125H9.375V3.75C9.375 3.91576 9.44085 4.07473 9.55806 4.19194C9.67527 4.30915 9.83424 4.375 10 4.375C10.1658 4.375 10.3247 4.30915 10.4419 4.19194C10.5592 4.07473 10.625 3.91576 10.625 3.75V3.125H14.375V3.75C14.375 3.91576 14.4408 4.07473 14.5581 4.19194C14.6753 4.30915 14.8342 4.375 15 4.375C15.1658 4.375 15.3247 4.30915 15.4419 4.19194C15.5592 4.07473 15.625 3.91576 15.625 3.75V3.125H16.3787C16.6758 3.12599 16.9604 3.24444 17.1705 3.4545C17.3806 3.66456 17.499 3.94918 17.5 4.24625V17.0037Z"
        fill="var(--primary)"
      ></path>
      <path
        d="M7.68311 7.05812L6.24999 8.49125L5.44186 7.68312C5.38421 7.62343 5.31524 7.57581 5.23899 7.54306C5.16274 7.5103 5.08073 7.49306 4.99774 7.49234C4.91475 7.49162 4.83245 7.50743 4.75564 7.53886C4.67883 7.57028 4.60905 7.61669 4.55037 7.67537C4.49168 7.73406 4.44528 7.80384 4.41385 7.88065C4.38243 7.95746 4.36661 8.03976 4.36733 8.12275C4.36805 8.20573 4.3853 8.28775 4.41805 8.364C4.45081 8.44025 4.49842 8.50922 4.55811 8.56687L5.80811 9.81687C5.92532 9.93404 6.08426 9.99986 6.24999 9.99986C6.41572 9.99986 6.57466 9.93404 6.69186 9.81687L8.56686 7.94187C8.68071 7.82399 8.74371 7.66612 8.74229 7.50224C8.74086 7.33837 8.67513 7.18161 8.55925 7.06573C8.44337 6.94985 8.28661 6.88412 8.12274 6.8827C7.95887 6.88127 7.80099 6.94427 7.68311 7.05812Z"
        fill="var(--primary)"
      ></path>
      <path
        d="M15 8.125H10.625C10.4592 8.125 10.3003 8.19085 10.1831 8.30806C10.0658 8.42527 10 8.58424 10 8.75C10 8.91576 10.0658 9.07473 10.1831 9.19194C10.3003 9.30915 10.4592 9.375 10.625 9.375H15C15.1658 9.375 15.3247 9.30915 15.4419 9.19194C15.5592 9.07473 15.625 8.91576 15.625 8.75C15.625 8.58424 15.5592 8.42527 15.4419 8.30806C15.3247 8.19085 15.1658 8.125 15 8.125Z"
        fill="var(--primary)"
      ></path>
      <path
        d="M7.68311 12.6831L6.24999 14.1162L5.44186 13.3081C5.38421 13.2484 5.31524 13.2008 5.23899 13.1681C5.16274 13.1353 5.08073 13.1181 4.99774 13.1173C4.91475 13.1166 4.83245 13.1324 4.75564 13.1639C4.67883 13.1953 4.60905 13.2417 4.55037 13.3004C4.49168 13.3591 4.44528 13.4288 4.41385 13.5056C4.38243 13.5825 4.36661 13.6648 4.36733 13.7477C4.36805 13.8307 4.3853 13.9127 4.41805 13.989C4.45081 14.0653 4.49842 14.1342 4.55811 14.1919L5.80811 15.4419C5.92532 15.559 6.08426 15.6249 6.24999 15.6249C6.41572 15.6249 6.57466 15.559 6.69186 15.4419L8.56686 13.5669C8.68071 13.449 8.74371 13.2911 8.74229 13.1272C8.74086 12.9634 8.67513 12.8066 8.55925 12.6907C8.44337 12.5749 8.28661 12.5091 8.12274 12.5077C7.95887 12.5063 7.80099 12.5693 7.68311 12.6831Z"
        fill="var(--primary)"
      ></path>
      <path
        d="M15 13.75H10.625C10.4592 13.75 10.3003 13.8158 10.1831 13.9331C10.0658 14.0503 10 14.2092 10 14.375C10 14.5408 10.0658 14.6997 10.1831 14.8169C10.3003 14.9342 10.4592 15 10.625 15H15C15.1658 15 15.3247 14.9342 15.4419 14.8169C15.5592 14.6997 15.625 14.5408 15.625 14.375C15.625 14.2092 15.5592 14.0503 15.4419 13.9331C15.3247 13.8158 15.1658 13.75 15 13.75Z"
        fill="var(--primary)"
      ></path>
    </svg>
  ),
  calenderInfo: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3787 1.875H15.625V1.25C15.625 1.08424 15.5592 0.925268 15.4419 0.808058C15.3247 0.690848 15.1658 0.625 15 0.625C14.8342 0.625 14.6753 0.690848 14.5581 0.808058C14.4408 0.925268 14.375 1.08424 14.375 1.25V1.875H10.625V1.25C10.625 1.08424 10.5592 0.925268 10.4419 0.808058C10.3247 0.690848 10.1658 0.625 10 0.625C9.83424 0.625 9.67527 0.690848 9.55806 0.808058C9.44085 0.925268 9.375 1.08424 9.375 1.25V1.875H5.625V1.25C5.625 1.08424 5.55915 0.925268 5.44194 0.808058C5.32473 0.690848 5.16576 0.625 5 0.625C4.83424 0.625 4.67527 0.690848 4.55806 0.808058C4.44085 0.925268 4.375 1.08424 4.375 1.25V1.875H3.62125C2.99266 1.87599 2.3901 2.12614 1.94562 2.57062C1.50114 3.0151 1.25099 3.61766 1.25 4.24625V17.0037C1.25099 17.6323 1.50114 18.2349 1.94562 18.6794C2.3901 19.1239 2.99266 19.374 3.62125 19.375H16.3787C17.0073 19.374 17.6099 19.1239 18.0544 18.6794C18.4989 18.2349 18.749 17.6323 18.75 17.0037V4.24625C18.749 3.61766 18.4989 3.0151 18.0544 2.57062C17.6099 2.12614 17.0073 1.87599 16.3787 1.875ZM17.5 17.0037C17.499 17.3008 17.3806 17.5854 17.1705 17.7955C16.9604 18.0056 16.6758 18.124 16.3787 18.125H3.62125C3.32418 18.124 3.03956 18.0056 2.8295 17.7955C2.61944 17.5854 2.50099 17.3008 2.5 17.0037V4.24625C2.50099 3.94918 2.61944 3.66456 2.8295 3.4545C3.03956 3.24444 3.32418 3.12599 3.62125 3.125H4.375V3.75C4.375 3.91576 4.44085 4.07473 4.55806 4.19194C4.67527 4.30915 4.83424 4.375 5 4.375C5.16576 4.375 5.32473 4.30915 5.44194 4.19194C5.55915 4.07473 5.625 3.91576 5.625 3.75V3.125H9.375V3.75C9.375 3.91576 9.44085 4.07473 9.55806 4.19194C9.67527 4.30915 9.83424 4.375 10 4.375C10.1658 4.375 10.3247 4.30915 10.4419 4.19194C10.5592 4.07473 10.625 3.91576 10.625 3.75V3.125H14.375V3.75C14.375 3.91576 14.4408 4.07473 14.5581 4.19194C14.6753 4.30915 14.8342 4.375 15 4.375C15.1658 4.375 15.3247 4.30915 15.4419 4.19194C15.5592 4.07473 15.625 3.91576 15.625 3.75V3.125H16.3787C16.6758 3.12599 16.9604 3.24444 17.1705 3.4545C17.3806 3.66456 17.499 3.94918 17.5 4.24625V17.0037Z"
        fill="#58bad7"
      ></path>
      <path
        d="M7.68311 7.05812L6.24999 8.49125L5.44186 7.68312C5.38421 7.62343 5.31524 7.57581 5.23899 7.54306C5.16274 7.5103 5.08073 7.49306 4.99774 7.49234C4.91475 7.49162 4.83245 7.50743 4.75564 7.53886C4.67883 7.57028 4.60905 7.61669 4.55037 7.67537C4.49168 7.73406 4.44528 7.80384 4.41385 7.88065C4.38243 7.95746 4.36661 8.03976 4.36733 8.12275C4.36805 8.20573 4.3853 8.28775 4.41805 8.364C4.45081 8.44025 4.49842 8.50922 4.55811 8.56687L5.80811 9.81687C5.92532 9.93404 6.08426 9.99986 6.24999 9.99986C6.41572 9.99986 6.57466 9.93404 6.69186 9.81687L8.56686 7.94187C8.68071 7.82399 8.74371 7.66612 8.74229 7.50224C8.74086 7.33837 8.67513 7.18161 8.55925 7.06573C8.44337 6.94985 8.28661 6.88412 8.12274 6.8827C7.95887 6.88127 7.80099 6.94427 7.68311 7.05812Z"
        fill="#58bad7"
      ></path>
      <path
        d="M15 8.125H10.625C10.4592 8.125 10.3003 8.19085 10.1831 8.30806C10.0658 8.42527 10 8.58424 10 8.75C10 8.91576 10.0658 9.07473 10.1831 9.19194C10.3003 9.30915 10.4592 9.375 10.625 9.375H15C15.1658 9.375 15.3247 9.30915 15.4419 9.19194C15.5592 9.07473 15.625 8.91576 15.625 8.75C15.625 8.58424 15.5592 8.42527 15.4419 8.30806C15.3247 8.19085 15.1658 8.125 15 8.125Z"
        fill="#58bad7"
      ></path>
      <path
        d="M7.68311 12.6831L6.24999 14.1162L5.44186 13.3081C5.38421 13.2484 5.31524 13.2008 5.23899 13.1681C5.16274 13.1353 5.08073 13.1181 4.99774 13.1173C4.91475 13.1166 4.83245 13.1324 4.75564 13.1639C4.67883 13.1953 4.60905 13.2417 4.55037 13.3004C4.49168 13.3591 4.44528 13.4288 4.41385 13.5056C4.38243 13.5825 4.36661 13.6648 4.36733 13.7477C4.36805 13.8307 4.3853 13.9127 4.41805 13.989C4.45081 14.0653 4.49842 14.1342 4.55811 14.1919L5.80811 15.4419C5.92532 15.559 6.08426 15.6249 6.24999 15.6249C6.41572 15.6249 6.57466 15.559 6.69186 15.4419L8.56686 13.5669C8.68071 13.449 8.74371 13.2911 8.74229 13.1272C8.74086 12.9634 8.67513 12.8066 8.55925 12.6907C8.44337 12.5749 8.28661 12.5091 8.12274 12.5077C7.95887 12.5063 7.80099 12.5693 7.68311 12.6831Z"
        fill="#58bad7"
      ></path>
      <path
        d="M15 13.75H10.625C10.4592 13.75 10.3003 13.8158 10.1831 13.9331C10.0658 14.0503 10 14.2092 10 14.375C10 14.5408 10.0658 14.6997 10.1831 14.8169C10.3003 14.9342 10.4592 15 10.625 15H15C15.1658 15 15.3247 14.9342 15.4419 14.8169C15.5592 14.6997 15.625 14.5408 15.625 14.375C15.625 14.2092 15.5592 14.0503 15.4419 13.9331C15.3247 13.8158 15.1658 13.75 15 13.75Z"
        fill="#58bad7"
      ></path>
    </svg>
  ),
  BellIcon: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 12H19C19.8284 12 20.5 12.6716 20.5 13.5C20.5 14.3284 19.8284 15 19 15H6C5.17157 15 4.5 14.3284 4.5 13.5C4.5 12.6716 5.17157 12 6 12H7.5L8.05827 6.97553C8.30975 4.71226 10.2228 3 12.5 3C14.7772 3 16.6903 4.71226 16.9417 6.97553L17.5 12Z"
        fill="#222B40"
      />
      <path
        opacity="0.3"
        d="M14.5 18C14.5 16.8954 13.6046 16 12.5 16C11.3954 16 10.5 16.8954 10.5 18C10.5 19.1046 11.3954 20 12.5 20C13.6046 20 14.5 19.1046 14.5 18Z"
        fill="#222B40"
      />
    </svg>
  ),
  UserSvg: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9848 15.3462C8.11714 15.3462 4.81429 15.931 4.81429 18.2729C4.81429 20.6148 8.09619 21.2205 11.9848 21.2205C15.8524 21.2205 19.1543 20.6348 19.1543 18.2938C19.1543 15.9529 15.8733 15.3462 11.9848 15.3462Z"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9848 12.0059C14.5229 12.0059 16.58 9.94779 16.58 7.40969C16.58 4.8716 14.5229 2.81445 11.9848 2.81445C9.44667 2.81445 7.38857 4.8716 7.38857 7.40969C7.38 9.93922 9.42381 11.9973 11.9524 12.0059H11.9848Z"
        stroke="var(--primary)"
        strokeWidth="1.42857"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  UserSvgGreen: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9715 29.3168C15.7197 29.3168 9.52686 30.4132 9.52686 34.8043C9.52686 39.1953 15.6804 40.331 22.9715 40.331C30.2233 40.331 36.4144 39.2328 36.4144 34.8435C36.4144 30.4543 30.2626 29.3168 22.9715 29.3168Z"
        stroke="#3AC977"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9714 23.0537C27.7304 23.0537 31.5875 19.1948 31.5875 14.4359C31.5875 9.67694 27.7304 5.81979 22.9714 5.81979C18.2125 5.81979 14.3536 9.67694 14.3536 14.4359C14.3375 19.1787 18.1696 23.0377 22.9107 23.0537H22.9714Z"
        stroke="#3AC977"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  UserThree: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.0396 20.974C36.6552 20.6065 38.6689 18.364 38.6746 15.6471C38.6746 12.9696 36.7227 10.7496 34.1633 10.3296"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M37.4912 27.262C40.0243 27.6407 41.7925 28.5276 41.7925 30.3557C41.7925 31.6139 40.96 32.4314 39.6137 32.9451"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7879 28.0373C16.7616 28.0373 11.6147 28.9504 11.6147 32.5973C11.6147 36.2423 16.7297 37.1817 22.7879 37.1817C28.8141 37.1817 33.9591 36.2779 33.9591 32.6292C33.9591 28.9804 28.846 28.0373 22.7879 28.0373Z"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7876 22.8325C26.742 22.8325 29.9483 19.6281 29.9483 15.6719C29.9483 11.7175 26.742 8.51123 22.7876 8.51123C18.8333 8.51123 15.627 11.7175 15.627 15.6719C15.612 19.6131 18.7939 22.8194 22.7351 22.8325H22.7876Z"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11.5344 20.974C8.91691 20.6065 6.90504 18.364 6.89941 15.6471C6.89941 12.9696 8.85129 10.7496 11.4107 10.3296"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8.0825 27.262C5.54937 27.6407 3.78125 28.5276 3.78125 30.3557C3.78125 31.6139 4.61375 32.4314 5.96 32.9451"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  Project: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-pie-chart"
    >
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path>
      <path d="M22 12A10 10 0 0 0 12 2v10z"></path>
    </svg>
  ),
  Message: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9026 8.85114L13.4593 12.4642C12.6198 13.1302 11.4387 13.1302 10.5992 12.4642L6.11844 8.85114"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9089 21C19.9502 21.0084 22 18.5095 22 15.4384V8.57001C22 5.49883 19.9502 3 16.9089 3H7.09114C4.04979 3 2 5.49883 2 8.57001V15.4384C2 18.5095 4.04979 21.0084 7.09114 21H16.9089Z"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Notification: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17.8476C17.6392 17.8476 20.2481 17.1242 20.5 14.2205C20.5 11.3188 18.6812 11.5054 18.6812 7.94511C18.6812 5.16414 16.0452 2 12 2C7.95477 2 5.31885 5.16414 5.31885 7.94511C5.31885 11.5054 3.5 11.3188 3.5 14.2205C3.75295 17.1352 6.36177 17.8476 12 17.8476Z"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3888 20.8572C13.0247 22.372 10.8967 22.3899 9.51947 20.8572"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Headersetting: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.8066 7.62355L20.1842 6.54346C19.6576 5.62954 18.4907 5.31426 17.5755 5.83866V5.83866C17.1399 6.09528 16.6201 6.16809 16.1307 6.04103C15.6413 5.91396 15.2226 5.59746 14.9668 5.16131C14.8023 4.88409 14.7139 4.56833 14.7105 4.24598V4.24598C14.7254 3.72916 14.5304 3.22834 14.17 2.85761C13.8096 2.48688 13.3145 2.2778 12.7975 2.27802H11.5435C11.0369 2.27801 10.5513 2.47985 10.194 2.83888C9.83666 3.19791 9.63714 3.68453 9.63958 4.19106V4.19106C9.62457 5.23686 8.77245 6.07675 7.72654 6.07664C7.40418 6.07329 7.08843 5.98488 6.8112 5.82035V5.82035C5.89603 5.29595 4.72908 5.61123 4.20251 6.52516L3.53432 7.62355C3.00838 8.53633 3.31937 9.70255 4.22997 10.2322V10.2322C4.82187 10.574 5.1865 11.2055 5.1865 11.889C5.1865 12.5725 4.82187 13.204 4.22997 13.5457V13.5457C3.32053 14.0719 3.0092 15.2353 3.53432 16.1453V16.1453L4.16589 17.2345C4.41262 17.6797 4.82657 18.0082 5.31616 18.1474C5.80575 18.2865 6.33061 18.2248 6.77459 17.976V17.976C7.21105 17.7213 7.73116 17.6515 8.21931 17.7821C8.70746 17.9128 9.12321 18.233 9.37413 18.6716C9.53867 18.9488 9.62708 19.2646 9.63043 19.5869V19.5869C9.63043 20.6435 10.4869 21.5 11.5435 21.5H12.7975C13.8505 21.5 14.7055 20.6491 14.7105 19.5961V19.5961C14.7081 19.088 14.9088 18.6 15.2681 18.2407C15.6274 17.8814 16.1154 17.6806 16.6236 17.6831C16.9451 17.6917 17.2596 17.7797 17.5389 17.9393V17.9393C18.4517 18.4653 19.6179 18.1543 20.1476 17.2437V17.2437L20.8066 16.1453C21.0617 15.7074 21.1317 15.1859 21.0012 14.6963C20.8706 14.2067 20.5502 13.7893 20.111 13.5366V13.5366C19.6717 13.2839 19.3514 12.8665 19.2208 12.3769C19.0902 11.8872 19.1602 11.3658 19.4153 10.9279C19.5812 10.6383 19.8213 10.3981 20.111 10.2322V10.2322C21.0161 9.70283 21.3264 8.54343 20.8066 7.63271V7.63271V7.62355Z"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12.175"
        cy="11.889"
        r="2.63616"
        stroke="var(--primary)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Logout: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="var(--primary)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line x1="21" y1="12" x2="9" y2="12"></line>
    </svg>
  ),

  //SideBar Menu
  Home: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.756 22 16.0829 22H18.0438C18.9596 22.0024 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z"
        fill="#90959F"
      />
    </svg>
  ),
  TaskIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_113_177)">
        <path
          d="M17 4H6C4.79111 4 4 4.7 4 6V18C4 19.3 4.79111 20 6 20H18C19.2 20 20 19.3 20 18V7.20711C20 7.0745 19.9473 6.94732 19.8536 6.85355L17 4ZM17 11H7V4H17V11Z"
          fill="#90959F"
        />
        <path
          opacity="0.3"
          d="M14.5 4H12.5C12.2239 4 12 4.22386 12 4.5V8.5C12 8.77614 12.2239 9 12.5 9H14.5C14.7761 9 15 8.77614 15 8.5V4.5C15 4.22386 14.7761 4 14.5 4Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_113_177">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ProjectIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_115_172)">
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.25933C12.1489 4.25921 12.3 4.29247 12.4426 4.36281C12.6398 4.46014 12.7994 4.61977 12.8967 4.81698L14.9389 8.95491L19.5054 9.61846C20.0519 9.69788 20.4306 10.2053 20.3512 10.7519C20.3196 10.9695 20.2171 11.1706 20.0596 11.3242L16.7553 14.5451L17.5353 19.0931C17.6287 19.6374 17.2631 20.1544 16.7188 20.2478C16.502 20.2849 16.279 20.2496 16.0844 20.1473L12 18V4.25933Z"
          fill="#4E5566"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 4.25933V18L7.91559 20.1473C7.42675 20.4043 6.82212 20.2163 6.56512 19.7275C6.46278 19.5328 6.42746 19.3099 6.46464 19.0931L7.24469 14.5451L3.94036 11.3242C3.54487 10.9387 3.53678 10.3055 3.92228 9.91006C4.07579 9.75258 4.27693 9.65009 4.49457 9.61846L9.06104 8.95492L11.1032 4.81699C11.2773 4.46426 11.6316 4.25961 12 4.25933Z"
          fill="#90959F"
        />
      </g>
      <defs>
        <clipPath id="clip0_115_172">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  Apps: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          d="M9.34933 14.8577C5.38553 14.8577 2 15.47 2 17.9174C2 20.3666 5.364 21 9.34933 21C13.3131 21 16.6987 20.3877 16.6987 17.9404C16.6987 15.4911 13.3347 14.8577 9.34933 14.8577Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M9.34935 12.5248C12.049 12.5248 14.2124 10.4062 14.2124 7.76241C14.2124 5.11865 12.049 3 9.34935 3C6.65072 3 4.48633 5.11865 4.48633 7.76241C4.48633 10.4062 6.65072 12.5248 9.34935 12.5248Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M16.1734 7.84876C16.1734 9.19508 15.7605 10.4513 15.0364 11.4948C14.9611 11.6022 15.0276 11.7468 15.1587 11.7698C15.3407 11.7996 15.5276 11.8178 15.7184 11.8216C17.6167 11.8705 19.3202 10.6736 19.7908 8.87119C20.4885 6.19677 18.4415 3.79544 15.8339 3.79544C15.5511 3.79544 15.2801 3.82419 15.0159 3.87689C14.9797 3.88456 14.9405 3.9018 14.921 3.93247C14.8955 3.97176 14.9141 4.02254 14.9395 4.05608C15.7233 5.13217 16.1734 6.44208 16.1734 7.84876Z"
          fill="white"
        />
        <path
          d="M21.7791 15.1693C21.4318 14.444 20.5932 13.9466 19.3173 13.7023C18.7155 13.5586 17.0854 13.3545 15.5697 13.3832C15.5472 13.3861 15.5345 13.4014 15.5325 13.411C15.5296 13.4263 15.5365 13.4493 15.5658 13.4656C16.2664 13.8048 18.9738 15.2805 18.6333 18.3928C18.6187 18.5289 18.7292 18.6439 18.8672 18.6247C19.5335 18.5318 21.2478 18.1705 21.7791 17.0475C22.0737 16.4534 22.0737 15.7634 21.7791 15.1693Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  Charts: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.2428 4.73756C15.2428 6.95855 17.0459 8.75902 19.2702 8.75902C19.5151 8.75782 19.7594 8.73431 20 8.68878V16.6615C20 20.0156 18.0215 22 14.6624 22H7.34636C3.97851 22 2 20.0156 2 16.6615V9.3561C2 6.00195 3.97851 4 7.34636 4H15.3131C15.2659 4.243 15.2423 4.49001 15.2428 4.73756ZM13.15 14.8966L16.0078 11.2088V11.1912C16.2525 10.8625 16.1901 10.3989 15.8671 10.1463C15.7108 10.0257 15.5122 9.97345 15.3167 10.0016C15.1211 10.0297 14.9453 10.1358 14.8295 10.2956L12.4201 13.3951L9.6766 11.2351C9.51997 11.1131 9.32071 11.0592 9.12381 11.0856C8.92691 11.1121 8.74898 11.2166 8.63019 11.3756L5.67562 15.1863C5.57177 15.3158 5.51586 15.4771 5.51734 15.6429C5.5002 15.9781 5.71187 16.2826 6.03238 16.3838C6.35288 16.485 6.70138 16.3573 6.88031 16.0732L9.35125 12.8771L12.0948 15.0283C12.2508 15.1541 12.4514 15.2111 12.6504 15.1863C12.8494 15.1615 13.0297 15.0569 13.15 14.8966Z"
          fill="white"
        />
        <circle opacity="0.4" cx="19.5" cy="4.5" r="2.5" fill="white" />
      </g>
    </svg>
  ),
  Bootstrap: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.4"
          d="M11.776 21.8374C9.49292 20.4273 7.37062 18.7645 5.44789 16.8796C4.0905 15.5338 3.05386 13.8905 2.41716 12.0753C1.27953 8.53523 2.60381 4.48948 6.30111 3.2884C8.25262 2.67553 10.375 3.05175 12.007 4.29983C13.6396 3.05315 15.7614 2.67705 17.713 3.2884C21.4103 4.48948 22.7435 8.53523 21.6058 12.0753C20.9743 13.8888 19.9438 15.5319 18.5929 16.8796C16.6684 18.7625 14.5463 20.4251 12.2648 21.8374L12.0159 22L11.776 21.8374Z"
          fill="white"
        />
        <path
          d="M12.0109 22L11.776 21.8374C9.49013 20.4274 7.36487 18.7647 5.43902 16.8796C4.0752 15.5356 3.03238 13.8922 2.39052 12.0753C1.26177 8.53523 2.58605 4.48948 6.28335 3.2884C8.23486 2.67553 10.3853 3.05204 12.0109 4.31057V22Z"
          fill="white"
        />
        <path
          d="M18.2304 9.99922C18.0296 9.98629 17.8425 9.8859 17.7131 9.72157C17.5836 9.55723 17.5232 9.3434 17.5459 9.13016C17.5677 8.4278 17.168 7.78851 16.5517 7.53977C16.1609 7.43309 15.9243 7.00987 16.022 6.59249C16.1148 6.18182 16.4993 5.92647 16.8858 6.0189C16.9346 6.027 16.9816 6.04468 17.0244 6.07105C18.2601 6.54658 19.0601 7.82641 18.9965 9.22576C18.9944 9.43785 18.9117 9.63998 18.7673 9.78581C18.6229 9.93164 18.4291 10.0087 18.2304 9.99922Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  Plugins: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.4"
          d="M10.0833 15.9579H3.50777C2.67555 15.9579 2 16.6217 2 17.4393C2 18.2558 2.67555 18.9206 3.50777 18.9206H10.0833C10.9155 18.9206 11.5911 18.2558 11.5911 17.4393C11.5911 16.6217 10.9155 15.9579 10.0833 15.9579Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M22 6.37855C22 5.56202 21.3244 4.89832 20.4933 4.89832H13.9178C13.0856 4.89832 12.41 5.56202 12.41 6.37855C12.41 7.19617 13.0856 7.85988 13.9178 7.85988H20.4933C21.3244 7.85988 22 7.19617 22 6.37855Z"
          fill="white"
        />
        <path
          d="M8.87774 6.37856C8.87774 8.24523 7.33886 9.75821 5.43887 9.75821C3.53999 9.75821 2 8.24523 2 6.37856C2 4.51298 3.53999 3 5.43887 3C7.33886 3 8.87774 4.51298 8.87774 6.37856Z"
          fill="white"
        />
        <path
          d="M22 17.3992C22 19.2648 20.4611 20.7778 18.5611 20.7778C16.6622 20.7778 15.1223 19.2648 15.1223 17.3992C15.1223 15.5325 16.6622 14.0196 18.5611 14.0196C20.4611 14.0196 22 15.5325 22 17.3992Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  Widget: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.4"
          d="M16.0755 2H19.4615C20.8637 2 22 3.14585 22 4.55996V7.97452C22 9.38864 20.8637 10.5345 19.4615 10.5345H16.0755C14.6732 10.5345 13.537 9.38864 13.537 7.97452V4.55996C13.537 3.14585 14.6732 2 16.0755 2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.53852 2H7.92449C9.32676 2 10.463 3.14585 10.463 4.55996V7.97452C10.463 9.38864 9.32676 10.5345 7.92449 10.5345H4.53852C3.13626 10.5345 2 9.38864 2 7.97452V4.55996C2 3.14585 3.13626 2 4.53852 2ZM4.53852 13.4655H7.92449C9.32676 13.4655 10.463 14.6114 10.463 16.0255V19.44C10.463 20.8532 9.32676 22 7.92449 22H4.53852C3.13626 22 2 20.8532 2 19.44V16.0255C2 14.6114 3.13626 13.4655 4.53852 13.4655ZM19.4615 13.4655H16.0755C14.6732 13.4655 13.537 14.6114 13.537 16.0255V19.44C13.537 20.8532 14.6732 22 16.0755 22H19.4615C20.8637 22 22 20.8532 22 19.44V16.0255C22 14.6114 20.8637 13.4655 19.4615 13.4655Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  Forms: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.4"
          d="M16.191 2H7.81C4.77 2 3 3.78 3 6.83V17.16C3 20.26 4.77 22 7.81 22H16.191C19.28 22 21 20.26 21 17.16V6.83C21 3.78 19.28 2 16.191 2Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.08002 6.64999V6.65999C7.64902 6.65999 7.30002 7.00999 7.30002 7.43999C7.30002 7.86999 7.64902 8.21999 8.08002 8.21999H11.069C11.5 8.21999 11.85 7.86999 11.85 7.42899C11.85 6.99999 11.5 6.64999 11.069 6.64999H8.08002ZM15.92 12.74H8.08002C7.64902 12.74 7.30002 12.39 7.30002 11.96C7.30002 11.53 7.64902 11.179 8.08002 11.179H15.92C16.35 11.179 16.7 11.53 16.7 11.96C16.7 12.39 16.35 12.74 15.92 12.74ZM15.92 17.31H8.08002C7.78002 17.35 7.49002 17.2 7.33002 16.95C7.17002 16.69 7.17002 16.36 7.33002 16.11C7.49002 15.85 7.78002 15.71 8.08002 15.74H15.92C16.319 15.78 16.62 16.12 16.62 16.53C16.62 16.929 16.319 17.27 15.92 17.31Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  Table: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.4"
          d="M6.70555 12.8905C6.18944 12.8905 5.77163 13.3145 5.77163 13.8383L5.51416 18.4171C5.51416 19.0846 6.04783 19.625 6.70555 19.625C7.36328 19.625 7.89577 19.0846 7.89577 18.4171L7.63947 13.8383C7.63947 13.3145 7.22167 12.8905 6.70555 12.8905Z"
          fill="white"
        />
        <path
          d="M7.98037 3.67345C7.98037 3.67345 7.71236 3.39789 7.54618 3.27793C7.30509 3.09264 7.00783 3 6.71173 3C6.37936 3 6.07039 3.10452 5.81877 3.30169C5.77313 3.34801 5.57886 3.5226 5.41852 3.68532C4.41204 4.6367 2.76539 7.12026 2.26215 8.42083C2.18257 8.618 2.01053 9.11685 2 9.38409C2 9.63827 2.05618 9.88294 2.17087 10.1145C2.3312 10.4044 2.58282 10.6372 2.88009 10.7642C3.08606 10.8462 3.70282 10.9733 3.71453 10.9733C4.38981 11.1016 5.48757 11.1704 6.70003 11.1704C7.85514 11.1704 8.90727 11.1016 9.59308 10.997C9.60478 10.9852 10.3702 10.8581 10.6335 10.7179C11.1133 10.4626 11.4118 9.96371 11.4118 9.43041V9.38409C11.4001 9.03608 11.1016 8.30444 11.0911 8.30444C10.5879 7.07394 9.02079 4.64858 7.98037 3.67345Z"
          fill="white"
        />
        <path
          opacity="0.4"
          d="M17.2947 11.1096C17.8108 11.1096 18.2286 10.6856 18.2286 10.1618L18.4849 5.58296C18.4849 4.91543 17.9524 4.375 17.2947 4.375C16.637 4.375 16.1033 4.91543 16.1033 5.58296L16.3608 10.1618C16.3608 10.6856 16.7786 11.1096 17.2947 11.1096Z"
          fill="white"
        />
        <path
          d="M21.8292 13.8853C21.6688 13.5955 21.4172 13.3639 21.1199 13.2356C20.914 13.1536 20.296 13.0265 20.2855 13.0265C19.6102 12.8983 18.5124 12.8294 17.3 12.8294C16.1449 12.8294 15.0928 12.8983 14.4069 13.0028C14.3952 13.0147 13.6298 13.1429 13.3665 13.2819C12.8855 13.5373 12.5883 14.0361 12.5883 14.5706V14.617C12.6 14.965 12.8972 15.6954 12.9089 15.6954C13.4122 16.926 14.9781 19.3526 16.0197 20.3265C16.0197 20.3265 16.2877 20.6021 16.4538 20.7209C16.6938 20.9074 16.991 21 17.2895 21C17.6207 21 17.9285 20.8955 18.1812 20.6983C18.2269 20.652 18.4212 20.4774 18.5815 20.3158C19.5868 19.3633 21.2346 16.8796 21.7367 15.5802C21.8175 15.3831 21.9895 14.883 22 14.617C22 14.3616 21.9438 14.1169 21.8292 13.8853Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  Pages: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5">
        <path
          opacity="0.4"
          d="M2.00018 11.0785C2.05018 13.4165 2.19018 17.4155 2.21018 17.8565C2.28118 18.7995 2.64218 19.7525 3.20418 20.4245C3.98618 21.3675 4.94918 21.7885 6.29218 21.7885C8.14818 21.7985 10.1942 21.7985 12.1812 21.7985C14.1762 21.7985 16.1122 21.7985 17.7472 21.7885C19.0712 21.7885 20.0642 21.3565 20.8362 20.4245C21.3982 19.7525 21.7592 18.7895 21.8102 17.8565C21.8302 17.4855 21.9302 13.1445 21.9902 11.0785H2.00018Z"
          fill="white"
        />
        <path
          d="M11.2454 15.3842V16.6782C11.2454 17.0922 11.5814 17.4282 11.9954 17.4282C12.4094 17.4282 12.7454 17.0922 12.7454 16.6782V15.3842C12.7454 14.9702 12.4094 14.6342 11.9954 14.6342C11.5814 14.6342 11.2454 14.9702 11.2454 15.3842Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.2113 14.5564C10.1113 14.9194 9.7623 15.1514 9.38431 15.1014C6.8333 14.7454 4.39531 13.8404 2.33731 12.4814C2.12631 12.3434 2.00031 12.1074 2.00031 11.8554V8.3894C2.00031 6.2894 3.71231 4.5814 5.81731 4.5814H7.78431C7.97231 3.1294 9.20231 2.0004 10.7043 2.0004H13.2863C14.7873 2.0004 16.0183 3.1294 16.2063 4.5814H18.1833C20.2823 4.5814 21.9903 6.2894 21.9903 8.3894V11.8554C21.9903 12.1074 21.8633 12.3424 21.6543 12.4814C19.5923 13.8464 17.1443 14.7554 14.5763 15.1104C14.5413 15.1154 14.5073 15.1174 14.4733 15.1174C14.1343 15.1174 13.8313 14.8884 13.7463 14.5524C13.5443 13.7564 12.8213 13.1994 11.9903 13.1994C11.1483 13.1994 10.4333 13.7444 10.2113 14.5564ZM13.2863 3.5004H10.7043C10.0313 3.5004 9.46931 3.9604 9.30131 4.5814H14.6883C14.5203 3.9604 13.9583 3.5004 13.2863 3.5004Z"
          fill="white"
        />
      </g>
    </svg>
  ),
  WhiteArrowUp: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="white" />
      <g clipPath="url(#clip0_3_443)">
        <path
          opacity="0.3"
          d="M13.0641 7.54535C13.3245 7.285 13.3245 6.86289 13.0641 6.60254C12.8038 6.34219 12.3817 6.34219 12.1213 6.60254L6.46445 12.2594C6.2041 12.5197 6.2041 12.9419 6.46445 13.2022C6.7248 13.4626 7.14691 13.4626 7.40726 13.2022L13.0641 7.54535Z"
          fill="black"
        />
        <path
          d="M7.40729 7.26921C7.0391 7.26921 6.74062 6.97073 6.74062 6.60254C6.74062 6.23435 7.0391 5.93587 7.40729 5.93587H13.0641C13.4211 5.93587 13.7147 6.21699 13.7302 6.57358L13.9659 11.9947C13.9819 12.3626 13.6966 12.6737 13.3288 12.6897C12.961 12.7057 12.6498 12.4205 12.6338 12.0526L12.4258 7.26921H7.40729Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_443">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 -1 18 18)"
          />
        </clipPath>
      </defs>
    </svg>
  ),

  DarkArrowUp: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="#222B40" />
      <g clipPath="url(#clip0_3_473)">
        <path
          opacity="0.3"
          d="M13.0641 7.54535C13.3245 7.285 13.3245 6.86289 13.0641 6.60254C12.8038 6.34219 12.3817 6.34219 12.1213 6.60254L6.46446 12.2594C6.20411 12.5197 6.20411 12.9419 6.46446 13.2022C6.72481 13.4626 7.14692 13.4626 7.40727 13.2022L13.0641 7.54535Z"
          fill="white"
        />
        <path
          d="M7.40728 7.26921C7.03909 7.26921 6.74061 6.97073 6.74061 6.60254C6.74061 6.23435 7.03909 5.93587 7.40728 5.93587H13.0641C13.4211 5.93587 13.7147 6.21699 13.7302 6.57358L13.9659 11.9947C13.9819 12.3626 13.6966 12.6737 13.3288 12.6897C12.9609 12.7057 12.6498 12.4205 12.6338 12.0526L12.4258 7.26921H7.40728Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_473">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="matrix(-1 0 0 -1 18 18)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  PlusSymbal: (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.83333 6.27083V1.60417C5.83333 0.959834 6.35567 0.4375 7 0.4375C7.64433 0.4375 8.16667 0.959834 8.16667 1.60417V6.27083H12.8333C13.4777 6.27083 14 6.79317 14 7.4375C14 8.08183 13.4777 8.60417 12.8333 8.60417H8.16667V13.2708C8.16667 13.9152 7.64433 14.4375 7 14.4375C6.35567 14.4375 5.83333 13.9152 5.83333 13.2708V8.60417H1.16667C0.522334 8.60417 0 8.08183 0 7.4375C0 6.79317 0.522334 6.27083 1.16667 6.27083H5.83333Z"
        fill="#222B40"
      />
    </svg>
  ),
  Shiled: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3_566)">
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 3V3.5C8 4.32843 8.67157 5 9.5 5H14.5C15.3284 5 16 4.32843 16 3.5V3H18C19.1046 3 20 3.89543 20 5V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V5C4 3.89543 4.89543 3 6 3H8Z"
          fill="#222B40"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.875 15.75C10.6354 15.75 10.3958 15.6542 10.2042 15.4625L8.2875 13.5458C7.90417 13.1625 7.90417 12.5875 8.2875 12.2042C8.67083 11.8208 9.29375 11.8208 9.62917 12.2042L10.875 13.45L14.0375 10.2875C14.4208 9.90417 14.9958 9.90417 15.3792 10.2875C15.7625 10.6708 15.7625 11.2458 15.3792 11.6292L11.5458 15.4625C11.3542 15.6542 11.1146 15.75 10.875 15.75Z"
          fill="#222B40"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2H14.5C14.7761 2 15 2.22386 15 2.5V3.5C15 3.77614 14.7761 4 14.5 4H9.5C9.22386 4 9 3.77614 9 3.5V2.5C9 2.22386 9.22386 2 9.5 2H11Z"
          fill="#222B40"
        />
      </g>
      <defs>
        <clipPath id="clip0_3_566">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ShiledPrimary: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9717 41.0539C22.9717 41.0539 37.3567 36.6983 37.3567 24.6908C37.3567 12.6814 37.878 11.7439 36.723 10.5889C35.5699 9.43391 24.858 5.69891 22.9717 5.69891C21.0855 5.69891 10.3736 9.43391 9.21863 10.5889C8.0655 11.7439 8.58675 12.6814 8.58675 24.6908C8.58675 36.6983 22.9717 41.0539 22.9717 41.0539Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M26.4945 26.4642L19.4482 19.4179"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M19.4487 26.4642L26.495 19.4179"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  Doller: (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4642 13.7074C11.4759 12.1252 10.8504 10.8738 9.60279 9.99009C8.6392 9.30968 7.46984 8.95476 6.33882 8.6137C3.98274 7.89943 3.29927 7.52321 3.29927 6.3965C3.29927 5.14147 4.93028 4.69493 6.32655 4.69493C7.34341 4.69493 8.51331 5.01109 9.23985 5.47964L10.6802 3.24887C9.73069 2.6333 8.43112 2.21342 7.14783 2.0831V0H4.49076V2.22918C2.12884 2.74876 0.640949 4.29246 0.640949 6.3965C0.640949 7.87005 1.25327 9.03865 2.45745 9.86289C3.37331 10.4921 4.49028 10.83 5.56927 11.1572C7.88027 11.8557 8.81873 12.2813 8.80805 13.691L8.80799 13.7014C8.80799 14.8845 7.24005 15.3051 5.89676 15.3051C4.62786 15.3051 3.248 14.749 2.46582 13.9222L0.535522 15.7481C1.52607 16.7957 2.96523 17.5364 4.4907 17.8267V20.0001H7.14783V17.8735C9.7724 17.4978 11.4616 15.9177 11.4642 13.7074Z"
        fill="#fff"
      />
    </svg>
  ),
  dollersecondary: (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4642 13.7074C11.4759 12.1252 10.8504 10.8738 9.60279 9.99009C8.6392 9.30968 7.46984 8.95476 6.33882 8.6137C3.98274 7.89943 3.29927 7.52321 3.29927 6.3965C3.29927 5.14147 4.93028 4.69493 6.32655 4.69493C7.34341 4.69493 8.51331 5.01109 9.23985 5.47964L10.6802 3.24887C9.73069 2.6333 8.43112 2.21342 7.14783 2.0831V0H4.49076V2.22918C2.12884 2.74876 0.640949 4.29246 0.640949 6.3965C0.640949 7.87005 1.25327 9.03865 2.45745 9.86289C3.37331 10.4921 4.49028 10.83 5.56927 11.1572C7.88027 11.8557 8.81873 12.2813 8.80805 13.691L8.80799 13.7014C8.80799 14.8845 7.24005 15.3051 5.89676 15.3051C4.62786 15.3051 3.248 14.749 2.46582 13.9222L0.535522 15.7481C1.52607 16.7957 2.96523 17.5364 4.4907 17.8267V20.0001H7.14783V17.8735C9.7724 17.4978 11.4616 15.9177 11.4642 13.7074Z"
        fill="var(--secondary)"
      ></path>
    </svg>
  ),
  dollerprimary: (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4642 13.7074C11.4759 12.1252 10.8504 10.8738 9.60279 9.99009C8.6392 9.30968 7.46984 8.95476 6.33882 8.6137C3.98274 7.89943 3.29927 7.52321 3.29927 6.3965C3.29927 5.14147 4.93028 4.69493 6.32655 4.69493C7.34341 4.69493 8.51331 5.01109 9.23985 5.47964L10.6802 3.24887C9.73069 2.6333 8.43112 2.21342 7.14783 2.0831V0H4.49076V2.22918C2.12884 2.74876 0.640949 4.29246 0.640949 6.3965C0.640949 7.87005 1.25327 9.03865 2.45745 9.86289C3.37331 10.4921 4.49028 10.83 5.56927 11.1572C7.88027 11.8557 8.81873 12.2813 8.80805 13.691L8.80799 13.7014C8.80799 14.8845 7.24005 15.3051 5.89676 15.3051C4.62786 15.3051 3.248 14.749 2.46582 13.9222L0.535522 15.7481C1.52607 16.7957 2.96523 17.5364 4.4907 17.8267V20.0001H7.14783V17.8735C9.7724 17.4978 11.4616 15.9177 11.4642 13.7074Z"
        fill="var(--primary)"
      ></path>
    </svg>
  ),

  WhiteLogo: (
    <svg
      width="43"
      height="40"
      viewBox="0 0 43 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.605 3.94728L34.9548 0.107383C34.7065 -0.0357944 34.4007 -0.0357944 34.1525 0.107383C26.172 4.71641 16.338 4.71713 8.35679 0.108821L8.35391 0.107383C8.10569 -0.0357944 7.7999 -0.0357944 7.55168 0.107383L0.901472 3.94656C0.65325 4.08974 0.5 4.35451 0.5 4.64159V12.3207C0.5 12.6077 0.65325 12.8725 0.901472 13.0157C8.88345 17.6225 13.8004 26.1384 13.8004 35.355V35.3579C13.8004 35.6442 13.9537 35.9097 14.2019 36.0529L20.8521 39.8928C20.9766 39.9647 21.1147 40 21.2536 40C21.3924 40 21.5306 39.964 21.655 39.8928L28.3053 36.0529C28.5535 35.9097 28.7067 35.645 28.7067 35.3579C28.706 26.1413 33.623 17.6247 41.605 13.0164L41.6064 13.0157C41.8546 12.8725 42.0079 12.6077 42.0079 12.3207V4.6423C42.0057 4.35523 41.8532 4.09046 41.605 3.94728ZM40.4013 11.858L20.8514 23.1453C20.6032 23.2885 20.4499 23.5533 20.4499 23.8403V29.8891C19.8168 30.2013 19.3923 30.8712 19.439 31.6345C19.4944 32.5325 20.2139 33.2627 21.1118 33.3304C22.1788 33.4109 23.0696 32.5684 23.0696 31.5187C23.0696 30.8035 22.6559 30.1848 22.0551 29.8883C22.0551 26.4319 23.8991 23.2381 26.8922 21.5099L27.0994 21.3905L27.1001 34.8952L21.2521 38.2718L15.4042 34.8952V12.3214C15.4042 12.035 15.2509 11.7695 15.0027 11.6264L9.76338 8.60163C9.76626 8.56206 9.7677 8.52249 9.7677 8.4822C9.7677 7.45549 8.91583 6.62736 7.88049 6.66694C6.93868 6.70291 6.17171 7.46988 6.13573 8.41169C6.09616 9.44703 6.92429 10.2996 7.951 10.2996C8.32513 10.2996 8.67264 10.1867 8.96115 9.99312C11.9542 11.7213 13.7983 14.9151 13.7983 18.3715V18.6097L2.10229 11.8587V5.10637L7.95028 1.72982L27.5002 13.0171C27.7484 13.1603 28.0542 13.1603 28.3024 13.0171L33.541 9.9924C33.8324 10.1881 34.1842 10.3011 34.5619 10.2989C35.5526 10.2931 36.3664 9.47581 36.3678 8.48508C36.3693 7.47996 35.5555 6.66549 34.5511 6.66549C33.5474 6.66549 32.7344 7.47923 32.7344 8.4822C32.7344 8.52249 32.7359 8.56206 32.7387 8.60163C29.745 10.3298 26.0569 10.3298 23.0631 8.60163L22.8573 8.48292L34.5511 1.72982L40.3991 5.10637V11.858H40.4013Z"
        fill="white"
      />
    </svg>
  ),
  RightCheck: (
    <svg
      width="93"
      height="93"
      viewBox="0 0 93 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_3_700)">
        <circle cx="46.5" cy="31.5" r="16.5" fill="#F8B940" />
      </g>
      <g clipPath="url(#clip0_3_700)">
        <path
          d="M52.738 25.3524C53.0957 24.9315 53.7268 24.8804 54.1476 25.2381C54.5684 25.5957 54.6196 26.2268 54.2619 26.6476L45.7619 36.6476C45.3986 37.0751 44.7549 37.1201 44.3356 36.7474L39.8356 32.7474C39.4228 32.3805 39.3857 31.7484 39.7526 31.3356C40.1195 30.9229 40.7516 30.8857 41.1643 31.2526L44.9002 34.5733L52.738 25.3524Z"
          fill="#222B40"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3_700"
          x="0"
          y="0"
          width="93"
          height="93"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="15" />
          <feGaussianBlur stdDeviation="15" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3_700"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3_700"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3_700">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(35 19)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  Stopboard: (
    <svg
      className="me-1"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.61051 15.3276H14.3978C15.5843 15.3276 16.329 14.0451 15.7395 13.0146L10.35 3.59085C9.75676 2.5536 8.26126 2.55285 7.66726 3.5901L2.26876 13.0139C1.67926 14.0444 2.42326 15.3276 3.61051 15.3276Z"
        stroke="#FF9F00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00189 10.0611V7.7361"
        stroke="#FF9F00"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.99625 12.375H9.00375"
        stroke="#FF9F00"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  RightClick: (
    <svg
      className="me-1"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 4.5L6.75 12.75L3 9"
        stroke="#3AC977"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  DeleteDanger: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8833 6.31213C12.8833 6.31213 12.5213 10.8021 12.3113 12.6935C12.2113 13.5968 11.6533 14.1261 10.7393 14.1428C8.99994 14.1741 7.25861 14.1761 5.51994 14.1395C4.64061 14.1215 4.09194 13.5855 3.99394 12.6981C3.78261 10.7901 3.42261 6.31213 3.42261 6.31213"
        stroke="#FF5E5E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.8055 4.1598H2.50012"
        stroke="#FF5E5E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6271 4.1598C11.1037 4.1598 10.6531 3.7898 10.5504 3.27713L10.3884 2.46647C10.2884 2.09247 9.94974 1.8338 9.56374 1.8338H6.74174C6.35574 1.8338 6.01707 2.09247 5.91707 2.46647L5.75507 3.27713C5.65241 3.7898 5.20174 4.1598 4.67841 4.1598"
        stroke="#FF5E5E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  EditPrimary: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.16492 13.6286H14"
        stroke="#0D99FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.52001 2.52986C9.0371 1.91186 9.96666 1.82124 10.5975 2.32782C10.6324 2.35531 11.753 3.22586 11.753 3.22586C12.446 3.64479 12.6613 4.5354 12.2329 5.21506C12.2102 5.25146 5.87463 13.1763 5.87463 13.1763C5.66385 13.4393 5.34389 13.5945 5.00194 13.5982L2.57569 13.6287L2.02902 11.3149C1.95244 10.9895 2.02902 10.6478 2.2398 10.3849L8.52001 2.52986Z"
        stroke="#0D99FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.34723 4.00059L10.9821 6.79201"
        stroke="#0D99FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Dotes: (
    <svg
      width="9"
      height="16"
      viewBox="0 0 9 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="1" height="1" fill="#888888" />
      <rect y="3" width="1" height="1" fill="#888888" />
      <rect y="6" width="1" height="1" fill="#888888" />
      <rect y="9" width="1" height="1" fill="#888888" />
      <rect y="12" width="1" height="1" fill="#888888" />
      <rect y="15" width="1" height="1" fill="#888888" />
      <rect x="4" width="1" height="1" fill="#888888" />
      <rect x="4" y="3" width="1" height="1" fill="#888888" />
      <rect x="4" y="6" width="1" height="1" fill="#888888" />
      <rect x="4" y="9" width="1" height="1" fill="#888888" />
      <rect x="4" y="12" width="1" height="1" fill="#888888" />
      <rect x="4" y="15" width="1" height="1" fill="#888888" />
      <rect x="8" width="1" height="1" fill="#888888" />
      <rect x="8" y="3" width="1" height="1" fill="#888888" />
      <rect x="8" y="6" width="1" height="1" fill="#888888" />
      <rect x="8" y="9" width="1" height="1" fill="#888888" />
      <rect x="8" y="12" width="1" height="1" fill="#888888" />
      <rect x="8" y="15" width="1" height="1" fill="#888888" />
    </svg>
  ),
  DropThreeDot: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
        stroke="#737B8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
        stroke="#737B8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
        stroke="#737B8B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  SocialHeart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M16.5,4.5 C14.8905,4.5 13.00825,6.32463215 12,7.5 C10.99175,6.32463215 9.1095,4.5 7.5,4.5 C4.651,4.5 3,6.72217984 3,9.55040872 C3,12.6834696 6,16 12,19.5 C18,16 21,12.75 21,9.75 C21,6.92177112 19.349,4.5 16.5,4.5 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
        />
        <path
          d="M12,19.5 C6,16 3,12.6834696 3,9.55040872 C3,6.72217984 4.651,4.5 7.5,4.5 C9.1095,4.5 10.99175,6.32463215 12,7.5 L12,19.5 Z"
          fill="#000000"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  Folder: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M5.84026576,8 L18.1597342,8 C19.1999115,8 20.0664437,8.79732479 20.1528258,9.83390904 L20.8194924,17.833909 C20.9112219,18.9346631 20.0932459,19.901362 18.9924919,19.9930915 C18.9372479,19.9976952 18.8818364,20 18.8264009,20 L5.1735991,20 C4.0690296,20 3.1735991,19.1045695 3.1735991,18 C3.1735991,17.9445645 3.17590391,17.889153 3.18050758,17.833909 L3.84717425,9.83390904 C3.93355627,8.79732479 4.80008849,8 5.84026576,8 Z M10.5,10 C10.2238576,10 10,10.2238576 10,10.5 L10,11.5 C10,11.7761424 10.2238576,12 10.5,12 L13.5,12 C13.7761424,12 14,11.7761424 14,11.5 L14,10.5 C14,10.2238576 13.7761424,10 13.5,10 L10.5,10 Z"
          fill="#000000"
        />
        <path
          d="M10,8 L8,8 L8,7 C8,5.34314575 9.34314575,4 11,4 L13,4 C14.6568542,4 16,5.34314575 16,7 L16,8 L14,8 L14,7 C14,6.44771525 13.5522847,6 13,6 L11,6 C10.4477153,6 10,6.44771525 10,7 L10,8 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
        />
      </g>
    </svg>
  ),
  SaleChart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
          fill="#000000"
          fillRule="nonzero"
        />
        <path
          d="M8.7295372,14.6839411 C8.35180695,15.0868534 7.71897114,15.1072675 7.31605887,14.7295372 C6.9131466,14.3518069 6.89273254,13.7189711 7.2704628,13.3160589 L11.0204628,9.31605887 C11.3857725,8.92639521 11.9928179,8.89260288 12.3991193,9.23931335 L15.358855,11.7649545 L19.2151172,6.88035571 C19.5573373,6.44687693 20.1861655,6.37289714 20.6196443,6.71511723 C21.0531231,7.05733733 21.1271029,7.68616551 20.7848828,8.11964429 L16.2848828,13.8196443 C15.9333973,14.2648593 15.2823707,14.3288915 14.8508807,13.9606866 L11.8268294,11.3801628 L8.7295372,14.6839411 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
          transform="translate(14.000019, 10.749981) scale(1, -1) translate(-14.000019, -10.749981) "
        />
      </g>
    </svg>
  ),
  Mobile: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z"
          fill="#000000"
          opacity="0.3"
        />
        <path
          d="M8,2.5 C7.30964406,2.5 6.75,3.05964406 6.75,3.75 L6.75,20.25 C6.75,20.9403559 7.30964406,21.5 8,21.5 L16,21.5 C16.6903559,21.5 17.25,20.9403559 17.25,20.25 L17.25,3.75 C17.25,3.05964406 16.6903559,2.5 16,2.5 L8,2.5 Z M8,1 L16,1 C17.5187831,1 18.75,2.23121694 18.75,3.75 L18.75,20.25 C18.75,21.7687831 17.5187831,23 16,23 L8,23 C6.48121694,23 5.25,21.7687831 5.25,20.25 L5.25,3.75 C5.25,2.23121694 6.48121694,1 8,1 Z M9.5,1.75 L14.5,1.75 C14.7761424,1.75 15,1.97385763 15,2.25 L15,3.25 C15,3.52614237 14.7761424,3.75 14.5,3.75 L9.5,3.75 C9.22385763,3.75 9,3.52614237 9,3.25 L9,2.25 C9,1.97385763 9.22385763,1.75 9.5,1.75 Z"
          fill="#000000"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  FolderHeart: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M3.5,21 L20.5,21 C21.3284271,21 22,20.3284271 22,19.5 L22,8.5 C22,7.67157288 21.3284271,7 20.5,7 L10,7 L7.43933983,4.43933983 C7.15803526,4.15803526 6.77650439,4 6.37867966,4 L3.5,4 C2.67157288,4 2,4.67157288 2,5.5 L2,19.5 C2,20.3284271 2.67157288,21 3.5,21 Z"
          fill="#000000"
          opacity="0.3"
        />
        <path
          d="M14.35,10.5 C13.54525,10.5 12.604125,11.4123161 12.1,12 C11.595875,11.4123161 10.65475,10.5 9.85,10.5 C8.4255,10.5 7.6,11.6110899 7.6,13.0252044 C7.6,14.5917348 9.1,16.25 12.1,18 C15.1,16.25 16.6,14.625 16.6,13.125 C16.6,11.7108856 15.7745,10.5 14.35,10.5 Z"
          fill="#000000"
          fillRule="nonzero"
          opacity="0.3"
        />
      </g>
    </svg>
  ),
  CardProgress: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.8961 26.5849C34.1612 26.5849 35.223 27.629 35.0296 28.8783C33.8947 36.2283 27.6026 41.6855 20.0138 41.6855C11.6178 41.6855 4.8125 34.8803 4.8125 26.4862C4.8125 19.5704 10.0664 13.1283 15.9816 11.6717C17.2526 11.3579 18.5553 12.252 18.5553 13.5605C18.5553 22.4263 18.8533 24.7197 20.5368 25.9671C22.2204 27.2145 24.2 26.5849 32.8961 26.5849Z"
        stroke="var(--primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1733 19.2019C41.2739 13.5059 34.2772 4.32428 25.7509 4.48217C25.0877 4.49402 24.5568 5.04665 24.5272 5.70783C24.3121 10.3914 24.6022 16.4605 24.764 19.2118C24.8134 20.0684 25.4864 20.7414 26.341 20.7907C29.1693 20.9526 35.4594 21.1736 40.0759 20.4749C40.7035 20.3802 41.1634 19.8355 41.1733 19.2019Z"
        stroke="var(--primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  ),
  VisitorPerson: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
          fill="var(--primary)"
          fillRule="nonzero"
          opacity="0.3"
        />
        <path
          d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
          fill="var(--primary)"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  Watch: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M10.9630156,7.5 L11.0475062,7.5 C11.3043819,7.5 11.5194647,7.69464724 11.5450248,7.95024814 L12,12.5 L15.2480695,14.3560397 C15.403857,14.4450611 15.5,14.6107328 15.5,14.7901613 L15.5,15 C15.5,15.2109164 15.3290185,15.3818979 15.1181021,15.3818979 C15.0841582,15.3818979 15.0503659,15.3773725 15.0176181,15.3684413 L10.3986612,14.1087258 C10.1672824,14.0456225 10.0132986,13.8271186 10.0316926,13.5879956 L10.4644883,7.96165175 C10.4845267,7.70115317 10.7017474,7.5 10.9630156,7.5 Z"
          fill="var(--secondary)"
        />
        <path
          d="M7.38979581,2.8349582 C8.65216735,2.29743306 10.0413491,2 11.5,2 C17.2989899,2 22,6.70101013 22,12.5 C22,18.2989899 17.2989899,23 11.5,23 C5.70101013,23 1,18.2989899 1,12.5 C1,11.5151324 1.13559454,10.5619345 1.38913364,9.65805651 L3.31481075,10.1982117 C3.10672013,10.940064 3,11.7119264 3,12.5 C3,17.1944204 6.80557963,21 11.5,21 C16.1944204,21 20,17.1944204 20,12.5 C20,7.80557963 16.1944204,4 11.5,4 C10.54876,4 9.62236069,4.15592757 8.74872191,4.45446326 L9.93948308,5.87355717 C10.0088058,5.95617272 10.0495583,6.05898805 10.05566,6.16666224 C10.0712834,6.4423623 9.86044965,6.67852665 9.5847496,6.69415008 L4.71777931,6.96995273 C4.66931162,6.97269931 4.62070229,6.96837279 4.57348157,6.95710938 C4.30487471,6.89303938 4.13906482,6.62335149 4.20313482,6.35474463 L5.33163823,1.62361064 C5.35654118,1.51920756 5.41437908,1.4255891 5.49660017,1.35659741 C5.7081375,1.17909652 6.0235153,1.2066885 6.2010162,1.41822583 L7.38979581,2.8349582 Z"
          fill="var(--secondary)"
          opacity="0.3"
        />
      </g>
    </svg>
  ),
  LivePerson: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <polygon points="0 0 24 0 24 24 0 24" />
        <path
          d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
          fill="#58bad7"
          fillRule="nonzero"
          opacity="0.3"
        />
        <path
          d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
          fill="#58bad7"
          fillRule="nonzero"
        />
      </g>
    </svg>
  ),
  Worldweb: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="&#x421;&#x43B;&#x43E;&#x439;_1"
      data-name="&#x421;&#x43B;&#x43E;&#x439; 1"
      viewBox="0 0 128 128"
      width="20"
      height="20"
    >
      <path
        d="M112.15,21.88a2,2,0,0,0-.45-.49,63.88,63.88,0,0,0-95.43,0,2,2,0,0,0-.43.47l0,.05a64,64,0,1,0,96.37,0Zm-2,80.41a71.55,71.55,0,0,0-14.38-6.39A101.55,101.55,0,0,0,100.64,66h23.31A59.71,59.71,0,0,1,110.15,102.3ZM4.05,66H27.36a101.55,101.55,0,0,0,4.87,29.91,71.55,71.55,0,0,0-14.38,6.39A59.71,59.71,0,0,1,4.05,66ZM18,25.55A71.76,71.76,0,0,0,32.3,31.89,101.43,101.43,0,0,0,27.36,62H4.05A59.71,59.71,0,0,1,18,25.55ZM66,36.64A105.35,105.35,0,0,0,92,33a99,99,0,0,1,4.68,29H66Zm0-4V4.12C76.14,5.25,85,14.91,90.6,29.23A101.46,101.46,0,0,1,66,32.64Zm-4,0a101.45,101.45,0,0,1-24.6-3.41C43,14.91,51.86,5.25,62,4.12Zm0,4V62H31.36A99,99,0,0,1,36,33,105.36,105.36,0,0,0,62,36.64ZM31.36,66H62V91.14a105.32,105.32,0,0,0-26,3.66A99.16,99.16,0,0,1,31.36,66ZM62,95.14v28.74C51.82,122.74,42.88,113,37.32,98.57A101.41,101.41,0,0,1,62,95.14Zm4,0a101.42,101.42,0,0,1,24.68,3.43C85.12,113,76.18,122.74,66,123.88Zm0-4V66H96.64A99.16,99.16,0,0,1,92,94.79,105.32,105.32,0,0,0,66,91.14ZM100.64,62A101.43,101.43,0,0,0,95.7,31.89,71.76,71.76,0,0,0,110,25.55,59.71,59.71,0,0,1,123.95,62Zm6.65-39.48a68.71,68.71,0,0,1-12.94,5.6C90.66,18.64,85.54,11,79.54,6.05A60,60,0,0,1,107.29,22.52ZM48.46,6.05c-6,4.92-11.11,12.58-14.8,22.07a68.71,68.71,0,0,1-12.94-5.6A60,60,0,0,1,48.46,6.05ZM20.57,105.34a68.45,68.45,0,0,1,13-5.66c3.7,9.58,8.84,17.32,14.88,22.27A60,60,0,0,1,20.57,105.34Zm59,16.61c6-5,11.18-12.69,14.88-22.27a68.46,68.46,0,0,1,13,5.66A60,60,0,0,1,79.54,121.95Z"
        fill="#58bad7"
      />
    </svg>
  ),
  trolly: (
    <svg
      id="_x31__px"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m17.5 13c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.467-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z" />
      <path d="m17.5 10c-.276 0-.5-.224-.5-.5v-6c0-.276.224-.5.5-.5s.5.224.5.5v6c0 .276-.224.5-.5.5z" />
      <path d="m20.5 7h-6c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h6c.276 0 .5.224.5.5s-.224.5-.5.5z" />
      <path d="m19.5 17h-13c-.238 0-.443-.168-.49-.402l-2-10c-.03-.147.009-.299.103-.415.095-.116.237-.183.387-.183h4c.276 0 .5.224.5.5s-.224.5-.5.5h-3.39l1.8 9h12.18l.277-1.385c.054-.271.317-.448.588-.392.271.054.446.317.392.588l-.357 1.787c-.047.234-.252.402-.49.402z" />
      <path d="m6.5 17c-.233 0-.442-.164-.49-.402l-2.479-12.394c-.14-.699-.759-1.206-1.471-1.206h-.001l-1.559.002c-.276 0-.5-.224-.5-.5s.223-.5.5-.5l1.558-.002h.002c1.188 0 2.219.845 2.452 2.01l2.478 12.394c.054.271-.122.534-.392.588-.033.007-.066.01-.098.01z" />
      <path d="m21.5 19h-17c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5h2c.276 0 .5.224.5.5s-.224.5-.5.5h-2c-.276 0-.5.224-.5.5s.224.5.5.5h17c.276 0 .5.224.5.5s-.224.5-.5.5z" />
      <path d="m8 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1z" />
      <path d="m17 24c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2zm0-3c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1z" />
    </svg>
  ),
  Complete: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9715 29.3168C15.7197 29.3168 9.52686 30.4132 9.52686 34.8043C9.52686 39.1953 15.6804 40.331 22.9715 40.331C30.2233 40.331 36.4144 39.2328 36.4144 34.8435C36.4144 30.4543 30.2626 29.3168 22.9715 29.3168Z"
        stroke="#3AC977"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9714 23.0537C27.7304 23.0537 31.5875 19.1948 31.5875 14.4359C31.5875 9.67694 27.7304 5.81979 22.9714 5.81979C18.2125 5.81979 14.3536 9.67694 14.3536 14.4359C14.3375 19.1787 18.1696 23.0377 22.9107 23.0537H22.9714Z"
        stroke="#3AC977"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Progress: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.8961 26.5849C34.1612 26.5849 35.223 27.629 35.0296 28.8783C33.8947 36.2283 27.6026 41.6855 20.0138 41.6855C11.6178 41.6855 4.8125 34.8803 4.8125 26.4862C4.8125 19.5704 10.0664 13.1283 15.9816 11.6717C17.2526 11.3579 18.5553 12.252 18.5553 13.5605C18.5553 22.4263 18.8533 24.7197 20.5368 25.9671C22.2204 27.2145 24.2 26.5849 32.8961 26.5849Z"
        stroke="var(--primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.1733 19.2019C41.2739 13.5059 34.2772 4.32428 25.7509 4.48217C25.0877 4.49402 24.5568 5.04665 24.5272 5.70783C24.3121 10.3914 24.6022 16.4605 24.764 19.2118C24.8134 20.0684 25.4864 20.7414 26.341 20.7907C29.1693 20.9526 35.4594 21.1736 40.0759 20.4749C40.7035 20.3802 41.1634 19.8355 41.1733 19.2019Z"
        stroke="var(--primary)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Started: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9717 41.0539C22.9717 41.0539 37.3567 36.6983 37.3567 24.6908C37.3567 12.6814 37.878 11.7439 36.723 10.5889C35.5699 9.43391 24.858 5.69891 22.9717 5.69891C21.0855 5.69891 10.3736 9.43391 9.21863 10.5889C8.0655 11.7439 8.58675 12.6814 8.58675 24.6908C8.58675 36.6983 22.9717 41.0539 22.9717 41.0539Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.4945 26.4642L19.4482 19.4179"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4487 26.4642L26.495 19.4179"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  Canceled: (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.0396 20.974C36.6552 20.6065 38.6689 18.364 38.6746 15.6471C38.6746 12.9696 36.7227 10.7496 34.1633 10.3296"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.4912 27.262C40.0243 27.6407 41.7925 28.5276 41.7925 30.3557C41.7925 31.6139 40.96 32.4314 39.6137 32.9451"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7879 28.0373C16.7616 28.0373 11.6147 28.9504 11.6147 32.5973C11.6147 36.2423 16.7297 37.1817 22.7879 37.1817C28.8141 37.1817 33.9591 36.2779 33.9591 32.6292C33.9591 28.9804 28.846 28.0373 22.7879 28.0373Z"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7876 22.8325C26.742 22.8325 29.9483 19.6281 29.9483 15.6719C29.9483 11.7175 26.742 8.51123 22.7876 8.51123C18.8333 8.51123 15.627 11.7175 15.627 15.6719C15.612 19.6131 18.7939 22.8194 22.7351 22.8325H22.7876Z"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5344 20.974C8.91691 20.6065 6.90504 18.364 6.89941 15.6471C6.89941 12.9696 8.85129 10.7496 11.4107 10.3296"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.0825 27.262C5.54937 27.6407 3.78125 28.5276 3.78125 30.3557C3.78125 31.6139 4.61375 32.4314 5.96 32.9451"
        stroke="#FF5E5E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  List: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24  24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <path
          d="M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z"
          fill="#000000"
        />
        <path
          d="M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z"
          fill="#000000"
          opacity="0.3"
        />
      </g>
    </svg>
  ),
  GridDots: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
      className="svg-main-icon"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24" />
        <rect
          fill="#000000"
          opacity="0.3"
          x="4"
          y="4"
          width="4"
          height="4"
          rx="1"
        />
        <path
          d="M5,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,13 C8,13.5522847 7.55228475,14 7,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M11,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,7 C14,7.55228475 13.5522847,8 13,8 L11,8 C10.4477153,8 10,7.55228475 10,7 L10,5 C10,4.44771525 10.4477153,4 11,4 Z M11,10 L13,10 C13.5522847,10 14,10.4477153 14,11 L14,13 C14,13.5522847 13.5522847,14 13,14 L11,14 C10.4477153,14 10,13.5522847 10,13 L10,11 C10,10.4477153 10.4477153,10 11,10 Z M17,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,7 C20,7.55228475 19.5522847,8 19,8 L17,8 C16.4477153,8 16,7.55228475 16,7 L16,5 C16,4.44771525 16.4477153,4 17,4 Z M17,10 L19,10 C19.5522847,10 20,10.4477153 20,11 L20,13 C20,13.5522847 19.5522847,14 19,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,11 C16,10.4477153 16.4477153,10 17,10 Z M5,16 L7,16 C7.55228475,16 8,16.4477153 8,17 L8,19 C8,19.5522847 7.55228475,20 7,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,17 C4,16.4477153 4.44771525,16 5,16 Z M11,16 L13,16 C13.5522847,16 14,16.4477153 14,17 L14,19 C14,19.5522847 13.5522847,20 13,20 L11,20 C10.4477153,20 10,19.5522847 10,19 L10,17 C10,16.4477153 10.4477153,16 11,16 Z M17,16 L19,16 C19.5522847,16 20,16.4477153 20,17 L20,19 C20,19.5522847 19.5522847,20 19,20 L17,20 C16.4477153,20 16,19.5522847 16,19 L16,17 C16,16.4477153 16.4477153,16 17,16 Z"
          fill="#000000"
        />
      </g>
    </svg>
  ),
  DashBoards: (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 100"
      style={{ enableBackground: "new 0 0 100 100" }}
      xmlSpace="preserve"
    >
      <style type="text/css">{`.st0{fill:#90959F;}`}</style>
      <image
        style={{ overflow: "visible" }}
        width="1366"
        height="695"
        xlinkHref="data:image/jpeg;base64,/9j/4AAQSkZJRgABAgECFAIUAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA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"
        transform="matrix(0.1353 0 0 0.1353 -36.4966 -107.0426)"
      ></image>
      <g>
        <g>
          <path
            class="st0"
            d="M38.04,85.96c0-4.1,0-7.83,0-11.9c-1.05,0-1.96,0-2.87,0c-7.37,0-14.75,0.02-22.12-0.02
     c-4.75-0.03-7.27-2.58-7.27-7.36C5.75,50.9,5.75,35.13,5.77,19.35c0.01-4.77,2.53-7.33,7.31-7.33c24.6-0.02,49.21-0.02,73.81,0
     c4.77,0,7.33,2.58,7.33,7.31c0.02,15.77,0.02,31.55-0.01,47.32c-0.01,4.9-2.53,7.37-7.51,7.39c-7.97,0.03-15.95,0.02-23.92,0.04
     c-0.17,0-0.33,0.08-0.74,0.19c0,3.72,0,7.51,0,11.69c2.27,0,4.55-0.09,6.83,0.05c0.76,0.05,1.49,0.66,2.23,1.01
     c-0.69,0.32-1.39,0.93-2.08,0.93c-12.69,0.06-25.38,0.06-38.06,0c-0.7,0-1.4-0.6-2.1-0.92c0.74-0.36,1.46-0.98,2.22-1.03
     C33.3,85.87,35.53,85.96,38.04,85.96z M7.79,61.01c28.34,0,56.3,0,84.27,0c0.06-0.56,0.14-0.89,0.14-1.23
     c0.01-13.54,0.03-27.08,0-40.63c-0.01-3.54-1.76-5.11-5.57-5.12c-24.43-0.01-48.85-0.01-73.28,0c-4.01,0-5.54,1.58-5.55,5.66
     c-0.01,8.57,0,17.14,0,25.71C7.79,50.54,7.79,55.68,7.79,61.01z M7.79,63.39c0,1.41-0.02,2.51,0,3.61c0.08,3.24,1.69,5,4.89,5
     c24.86,0.03,49.72,0.02,74.58,0.02c0.34,0,0.69,0,1.03-0.06c2.18-0.4,3.58-1.68,3.84-3.9c0.17-1.49,0.03-3.02,0.03-4.68
     C63.96,63.39,36.06,63.39,7.79,63.39z M40.3,85.74c6.62,0,12.98,0,19.32,0c0-3.96,0-7.69,0-11.45c-6.53,0-12.88,0-19.32,0
     C40.3,78.18,40.3,81.84,40.3,85.74z"
          />
          <path
            class="st0"
            d="M27.03,54.78c-5.38-0.26-10.12-3.15-12.75-8.86c-2.63-5.69-1.82-11.17,1.96-16.21
     c1.17-1.56,2.13-1.59,3.47-0.15c2.39,2.57,4.85,5.09,7.44,7.46c0.85,0.77,2.19,1.34,3.33,1.39c3.5,0.17,7.02,0.11,10.53,0.02
     c1.87-0.05,2.36,0.74,2.2,2.5C42.5,48.72,35.84,54.8,27.03,54.78z M19.06,49.34c4.82,3.63,9.35,4.39,14.15,2.33
     c4.68-2.01,7.24-5.72,7.99-11.15c-4.26,0-8.25-0.02-12.24,0.03c-0.44,0.01-0.94,0.4-1.3,0.73C24.9,43.83,22.16,46.42,19.06,49.34z
      M17.94,31.09c-3.9,3.5-4.39,13.16-0.26,16.24c2.9-2.73,5.73-5.4,8.65-8.15C23.58,36.53,20.82,33.87,17.94,31.09z"
          />
          <path
            class="st0"
            d="M41.25,36.78c-2.05,0-4.11-0.04-6.16,0.01c-1.42,0.03-2.01-0.57-2-1.99c0.03-4.11,0.04-8.22-0.01-12.33
     c-0.02-1.61,0.72-2.03,2.22-1.98c7.09,0.24,13.97,7.24,14.05,14.29c0.02,1.42-0.51,2.04-1.94,2.01
     C45.35,36.75,43.3,36.79,41.25,36.78z M35.13,22.75c0,3.62-0.04,7.1,0.05,10.58c0.01,0.48,0.67,1.34,1.06,1.35
     c3.61,0.1,7.23,0.06,10.86,0.06C46.69,28.15,41.57,23.01,35.13,22.75z"
          />
          <path
            class="st0"
            d="M78.8,44.6c0-2.65,0.05-5.3-0.02-7.94c-0.04-1.53,0.55-2.16,2.09-2.14c7.54,0.14,6.18-0.96,6.29,5.86
     c0.06,4.1-0.05,8.2,0.02,12.3c0.02,1.55-0.55,2.17-2.09,2.13c-7.64-0.17-6.12,0.96-6.29-5.86C78.77,47.5,78.8,46.05,78.8,44.6z
      M84.95,52.62c0-5.39,0-10.63,0-15.87c-1.45,0-2.68,0-3.97,0c0,5.37,0,10.55,0,15.87C82.38,52.62,83.61,52.62,84.95,52.62z"
          />
          <path
            class="st0"
            d="M74.4,46.67c0,2.05-0.03,4.1,0.01,6.15c0.03,1.41-0.58,2-1.99,1.98c-7.73-0.16-6.27,1.03-6.4-6.01
     c-0.05-2.65,0.04-5.3-0.02-7.94c-0.03-1.54,0.62-2.15,2.14-2.13c7.45,0.14,6.14-0.97,6.28,5.91c0.01,0.68,0,1.37,0,2.05
     C74.42,46.67,74.41,46.67,74.4,46.67z M68.2,40.85c0,4.05,0,7.83,0,11.68c1.45,0,2.73,0,4.02,0c0-4.02,0-7.81,0-11.68
     C70.84,40.85,69.67,40.85,68.2,40.85z"
          />
          <path
            class="st0"
            d="M31.19,28.84c0,2.06,0.04,4.12-0.03,6.17c-0.02,0.53-0.26,1.32-0.64,1.5c-0.35,0.17-1.15-0.18-1.51-0.53
     c-3.05-3.01-6.03-6.1-9.07-9.12c-1.01-1-0.72-1.74,0.2-2.56c2.6-2.3,5.59-3.59,9.07-3.82c1.45-0.09,2.04,0.5,2.01,1.92
     c-0.04,2.14-0.01,4.29-0.01,6.43C31.2,28.84,31.2,28.84,31.19,28.84z M29.05,22.04c-2.74,1.19-5.02,2.19-7.23,3.15
     c2.6,2.77,4.8,5.1,7.23,7.69C29.05,29.37,29.05,26.18,29.05,22.04z"
          />
          <path
            class="st0"
            d="M70.34,21.07c4.88,0,9.76-0.03,14.64,0.05c0.69,0.01,1.36,0.6,2.04,0.92c-0.67,0.35-1.33,0.99-2,1
     c-9.84,0.07-19.69,0.07-29.53,0.01c-0.68,0-1.36-0.63-2.04-0.97c0.67-0.33,1.33-0.94,2.01-0.96
     C60.41,21.03,65.38,21.07,70.34,21.07z"
          />
          <path
            class="st0"
            d="M70.18,29.5c-4.8,0-9.59,0.04-14.39-0.04c-0.79-0.01-1.57-0.58-2.35-0.89c0.74-0.37,1.48-1.04,2.22-1.05
     c9.68-0.07,19.35-0.07,29.03-0.01c0.78,0.01,1.56,0.61,2.34,0.93c-0.82,0.35-1.64,0.99-2.46,1.01
     C79.77,29.55,74.97,29.5,70.18,29.5z"
          />
          <path
            class="st0"
            d="M53.24,48.93c0-6.33,0-6.3,6.36-5.89c1.52,0.1,2.14,0.67,2.1,2.19c-0.06,2.48-0.06,4.96,0,7.44
     c0.04,1.53-0.58,2.25-2.13,2.1c-0.08-0.01-0.17,0-0.26,0C52.11,54.7,53.36,55.62,53.24,48.93z M55.45,45.24c0,2.62,0,4.97,0,7.37
     c1.45,0,2.69,0,4.07,0c0-2.51,0-4.86,0-7.37C58.14,45.24,56.9,45.24,55.45,45.24z"
          />
        </g>
      </g>
    </svg>
  ),
};
const appTheme = {
  IMAGES,
  SVGICON,
};
export default appTheme;
